<template>
	<div v-title title="商品详情" class="detail-page">
		<Swiper :list="data.product.albumPics.split(',')" />

		<!-- 优惠信息 -->
		<div class="discount-info">
			<div class="line-one">
				<div class="price-box">
					<span class="symbol">¥</span>
					<span class="price-big">{{
			$accounting
				.toFixed(submitProductForm.selectedSku.guessAmt, 2)
				.split('.')[0]
		}}</span>
					<span class="price-small">.{{
				$accounting
					.toFixed(submitProductForm.selectedSku.guessAmt, 2)
					.split('.')[1]
			}}</span>
				</div>

				<span class="text-bg">预估到手价</span>
				<span class="text">最高{{ data.product.maxFreeTerm }}期免息</span>
			</div>
			<div class="line-two" v-if="submitProductForm.selectedSku.couponAmt != 0">
				预估到手价 = 商城价（¥{{
			$accounting.toFixed(submitProductForm.selectedSku.price, 2)
		}}）- 店铺券（¥{{ $accounting.toFixed(submitProductForm.selectedSku.couponAmt, 2) }}）
			</div>
			<div class="line-two" v-else>
				预估到手价 = 商城价（¥{{
			$accounting.toFixed(submitProductForm.selectedSku.price, 2)
		}}）
			</div>
		</div>

		<!-- 标题栏信息 -->
		<div class="title-info">
			<div class="price-info">
				<span class="price">商城价 ¥{{
				$roundHalfUp(
					$subtract(
						submitProductForm.selectedSku.price,
						submitProductForm.selectedSku.couponAmt
					),
					2
				)
			}}起</span>
				<span class="tag" v-if="data.product.freeTerm"> 免息</span>
				<span class="text red" v-if="data.product.freeTerm">
					¥{{
			$roundHalfUp(
				$divide(
					$subtract(
						submitProductForm.selectedSku.price,
						submitProductForm.selectedSku.couponAmt
					),
					data.product.maxFreeTerm
				),
				2
			)
		}}</span>
				<span class="text" v-if="data.product.freeTerm">/期起 </span>
			</div>
			<div class="coupons-info">
				<div class="coupons-tag">
					<span class="tag" v-if="submitProductForm.selectedSku.couponAmt != 0">
						店铺券¥{{
			$accounting.toFixed(submitProductForm.selectedSku.couponAmt, 2)
		}}
					</span>
					<span class="tag" v-if="data.product.freeTerm">最高{{ data.product.maxFreeTerm }}期免息</span>
				</div>
				<div class="coupons-btn" @click="getCouponList">
					<span class="btn-text"> 领券 </span>
					<img class="img" src="@/assets/images/product/icon_more_green.png" />
				</div>
			</div>
			<div class="title">
				{{ data.product.name }}
			</div>
		</div>

		<!-- 规格选择信息 -->
		<div class="box specifications-info">
			<div class="line">
				<div class="key">选择</div>
				<div class="value" @click="showSkuActionSheet">
					<span class="text">{{
			submitProductForm.selectedAttributeDesc
		}}</span>
					<img class="img" src="@/assets/images/product/icon_more.png" />
				</div>
			</div>
			<div class="items">
				<div class="guige_box">
					<div class="guige_box_item" @click="changeProductSku(item.skuId)" :class="submitProductForm.selectedSkuId == item.skuId
			? 'border_juhong'
			: 'border_normal'
			" style="width: 4rem; height: 4rem" v-for="item in data.skuStockList" :key="item.skuId">
						<van-image width="4rem" fill height="4rem" :src="item.pic" />
						<span class="sell-out" v-if="!(item.publishCount - item.useCount - item.lockStock > 0)">售罄</span>
					</div>
				</div>
			</div>
			<div class="line">
				<div class="key">送至</div>
				<div class="value" @click="getDeliverToList">
					<span class="text" v-if="submitProductForm.selectedArea">{{ submitProductForm.selectedArea }}</span>
					<span class="text grey" v-else>请选择地址</span>
					<img class="img" src="@/assets/images/product/icon_more.png" />
				</div>
			</div>
			<div class="freight" v-if="submitProductForm.selectedArea">
				<span class="freight-key">运费：</span>
				<span class="freight-val" v-if="deliveryNotSupported">暂不支持配送</span>
				<span class="freight-val" v-else-if="submitProductForm.freight == 0">包邮</span>
				<span class="freight-val" v-else>¥{{ $accounting.toFixed(submitProductForm.freight, 2) }}</span>
			</div>
			<div class="line" v-if="data.productParamList && data.productParamList.length">
				<div class="key">参数</div>
				<div class="value" @click="canshuShow = !canshuShow">
					<span class="text">{{ getProductParamDesc(data) }}</span>
					<img class="img" src="@/assets/images/product/icon_more.png" />
				</div>
			</div>
			<div class="line">
				<div class="key">保障</div>
				<div class="value" @click="fuwushuomingshow = !fuwushuomingshow">
					<span class="text">7天无理由退换</span>
					<img class="img" src="@/assets/images/product/icon_more.png" />
				</div>
			</div>
			<div class="line">
				<div class="key">服务</div>
				<div class="value" @click="fuwushow = !fuwushow">
					<span class="text">由{{ shop.name }}发货并提供服务</span>
					<img class="img" src="@/assets/images/product/icon_more.png" />
				</div>
			</div>
		</div>

		<!-- 商品评价 -->
		<!-- <div class="box goods-evaluate">
			<div class="title-line">
				<span class="text">商品评价</span>
				<span class="num">（{{ data.commentCnt }}）</span>
				<div class="flex1"></div>
				<span class="text-all" @click="$router.push('/goodsEvaluate?id=' + data.product.id)">查看全部</span>
				<img class="img" @click="$router.push('/goodsEvaluate?id=' + data.product.id)"
					src="@/assets/images/product/icon_more.png" />
			</div>
			<div class="evaluate-list">
				<div class="evaluate-item">
					<div class="img-name">
						<img class="img" src="" />
						<span class="name">·
							权志龙Q
						</span>
					</div>
					<div class="content">
						无
					</div>
				</div>
			</div>
		</div> -->
		<div class="box goods-evaluate">
			<div class="title-line">
				<span class="text">商品评价</span>
				<span class="num">（{{ data.commentCnt }}）</span>
				<div class="flex1"></div>
				<span class="text-all" v-if="data.commentCnt != 0"
					@click="$router.push('/goodsEvaluate?id=' + data.product.id)">查看全部</span>
				<img class="img" v-if="data.commentCnt != 0" @click="$router.push('/goodsEvaluate?id=' + data.product.id)"
					src="@/assets/images/product/icon_more.png" />
			</div>
			<div class="evaluate-list">
				<div class="evaluate-item" v-for="comment in data.commentLimitList" :key="comment.id">
					<div class="img-name">
						<img class="img" :src="comment.memberIcon" />
						<span class="name">·
							{{ formatNickName(comment.memberNickName) }}
						</span>
					</div>
					<div class="content">
						{{ comment.content || '无' }}
					</div>
				</div>
			</div>
		</div>

		<!-- 进入店铺 -->
		<div class="box shop-info" @click="goHome">
			<img class="logo" :src="shop.logo" />
			<span class="text">{{ shop.name }}</span>
			<div class="flex1"></div>
			<span class="text-all">进入店铺</span>
			<img class="img" src="@/assets/images/product/icon_more.png" />
		</div>

		<!-- 相关推荐 -->
		<div class="box recommend-info">
			<div class="title">相关推荐</div>
			<van-swipe class="goods-swiper" :autoplay="30000" indicator-color="#00754A" @change="getProductList">
				<van-swipe-item v-for="(v, index) in productData.totalPage" :key="index">
					<div class="goods-swiper-item">
						<div class="goods-item" @click="gotoProductDetail(item.product.publishId)"
							v-for="(item, index) in productData.list" :key="index">
							<van-image class="img" style="width: 100%; height: 30vw" :src="item.product.pic" />
							<div class="name">
								{{ item.product.name }}
							</div>
							<div class="price">
								<span class="symbol">¥</span>
								<span class="num">{{ $accounting.toFixed(item.product.price, 2) }}</span>
								<span class="text">/期起</span>
							</div>
						</div>
					</div>
				</van-swipe-item>
			</van-swipe>
		</div>

		<!-- 商品详情 -->
		<div class="goods-detail">
			<img class="img" src="@/assets/images/product/bg_detail.png" />
			<span class="text">商品详情</span>
		</div>
		<div class="detal_choose bg_white over_write_img" v-html="data.product.detailMobileHtml"></div>

		<!-- 价格说明等 -->
		<div class="detal_choose bg_white">
			<van-cell-group>
				<template slot="title">
					<span class="siyuancu" style="color: #323233; font-size: 15px">
						价格说明
					</span>
				</template>
				<van-cell>

					<template slot="title">
						<van-icon name="price-desc-title" class-prefix="van-icon" />
						划线价格
					</template>

					<template slot="label">
						商品的专柜价、吊牌价、正品零售价、厂商指导价或该商品的曾经展示过的销售价等，并非原价，仅供参考
					</template>
				</van-cell>

				<van-cell>

					<template slot="title">
						<van-icon name="price-desc-title" class-prefix="van-icon" />
						未划线价格
					</template>

					<template slot="label">
						商品的实时标价，不因表述的差异改变性质。具体成交价格根据商品参加的活动，最终以订单结算页价格为准
					</template>
				</van-cell>

				<van-cell>

					<template slot="title">
						<van-icon name="price-desc-title" class-prefix="van-icon" />
						异常问题
					</template>

					<template slot="label">
						商品的具体售价以订单结算页为准，如您发现活动商品售价或促销信息异常，建议购买前先联系商户咨询。
					</template>
				</van-cell>

				<van-cell title="退换货说明">

					<template slot="label">
						持卡人如有退换货需求，可向合作商户进行咨询，或在买单吧提交相关申请。
					</template>
				</van-cell>

				<van-cell title="温馨提示">

					<template slot="label">
						<i class="price-desc-circle"></i>
						以上商品、商品标题、描述、图片及宣传内容等均来自免息商城合作商户“{{
			shop.invoiceProvideCompany
		}}”，其真实性、准确性和合法性由信息拥有者，即{{
				shop.invoiceProvideCompany
			}}负责，如有问题请与该商户联系，您可在商品详情页-左下角“客服”标识联系该商户。合作商户
						({{
				shop.invoiceProvideCompany
			}})需按照中国境内相关法律法规的规定提供商品的销售及售后服务。持卡人如遇任何商品销售、质量及配送等问题引发的索赔、质询及投诉由该商户负责处理和解决，商户客服电话:
						{{ shop.customerServicePhone }}。
						<br />
						<i class="price-desc-circle"></i>
						抢购商品数量有限，抢完即止，因活动火爆，已售数量更新可能存在延时。
						<br />
						<i class="price-desc-circle"></i>
						抢购商品抢购成功，最终以订单支付成功为准。
						<br />
						<i class="price-desc-circle"></i>
						为保障您的资金账户安全，请不要将账户及密码等重要信息告知他人。
					</template>
				</van-cell>
			</van-cell-group>
		</div>

		<!-- 底部按钮 -->
		<van-goods-action class="bottom-btn">
			<div class="btn" @click="showKefu">
				<img class="icon" src="@/assets/images/product/icon_kf.png" />
				<span class="text">客服</span>
			</div>
			<div class="btn" @click="goHome">
				<img class="icon" src="@/assets/images/product/icon_home.png" />
				<span class="text">首页</span>
			</div>
			<div class="flex1"></div>
			<div class="buy" @click="showSkuActionSheet"
				v-if="submitProductForm.selectedSku.publishCount - submitProductForm.selectedSku.useCount - submitProductForm.selectedSku.lockStock > 0">
				立即购买</div>
			<div class="buy grey" v-else>商品已售罄</div>
		</van-goods-action>

		<!-- 商品参数--弹框 -->
		<van-action-sheet class="sheet-dialog" v-model="canshuShow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">商品参数</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="canshuShow = !canshuShow" />
			</div>
			<div class="key-val" v-for="item, index in data.productParamList" :key="index">
				<span class="key">{{ item.name }}</span>
				<span class="val">{{ item.valueList ? item.valueList.join(',') : '' }}</span>
			</div>
			<div class="btn" @click="canshuShow = !canshuShow">我知道了</div>
		</van-action-sheet>

		<!-- 商品服务--弹框 -->
		<van-action-sheet class="sheet-dialog" v-model="fuwushow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">商品服务</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="fuwushow = !fuwushow" />
			</div>
			<div class="key-val">
				<span class="key">发货/发票提供</span>
				<span class="val">{{ shop.invoiceProvideCompany }}</span>
			</div>
			<div class="key-val">
				<span class="key">客服电话</span>
				<span class="val">{{ shop.customerServicePhone }}</span>
			</div>
			<div class="key-val">
				<span class="key">服务时间</span>
				<span class="val">{{ shop.customerServiceTime }}</span>
			</div>
			<div class="key-val">
				<span class="key">售后说明</span>
				<span class="val">正品保障：我司承诺商品均为官方正品行货；七天退换：商品支持七天无理由退换货，在不影响商品二次销售的情况下，支持客户承担运费退换货。</span>
			</div>
			<div class="key-val">
				<span class="key">营业执照</span>
				<van-image class="img" fit="cover" :src="shop.businessLicense" />
			</div>
			<div class="btn" @click="fuwushow = !fuwushow">我知道了</div>
		</van-action-sheet>

		<!-- 商品保障--弹框 -->
		<van-action-sheet class="sheet-dialog" v-model="fuwushuomingshow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">商品保障</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="fuwushuomingshow = !fuwushuomingshow" />
			</div>
			<div class="icon-val">
				<img class="icon" src="@/assets/images/product/icon_serve.png" />
				<span class="val">7天无理由退换</span>
			</div>
			<div class="explain">
				此商品支持七天无理由退换货，在不影响商品二次销售的情况下，支持客户承担运费退换货。
			</div>
			<div class="btn" @click="fuwushuomingshow = !fuwushuomingshow">我知道了</div>
		</van-action-sheet>

		<!-- 客服--弹框 -->
		<van-action-sheet class="sheet-dialog linear-gradient" v-model="kefushow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">云卡商城平台</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="kefushow = !kefushow" />
			</div>
			<img class="bg-serve" src="@/assets/images/product/bg_serve.png" />
			<div class="items">
				<div class="item" @click="phoneNumber">
					<span class="text">客服电话</span>
					<span class="time">{{ shop.customerServiceTime }}</span>
					<img class="icon" src="@/assets/images/product/icon_tel.png" />
				</div>
				<div class="item" @click="phoneNumber2">
					<span class="text">在线客服</span>
					<span class="time"> {{ shop.onlineServiceTime }} </span>
					<img class="icon" src="@/assets/images/product/icon_net.png" />
				</div>
			</div>
		</van-action-sheet>

		<!-- 活动优惠券--弹框 -->
		<van-action-sheet class="sheet-dialog" v-model="huodongShow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">优惠券</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="huodongShow = !huodongShow" />
			</div>
			<div class="no-more" v-if="!couponData.pendingReceiveList ||
			couponData.pendingReceiveList.length === 0">
				<img class="img" src="@/assets/images/coupon/bg_no_more.png" alt="" />
				<span class="tips">抱歉，暂无优惠券呢～</span>
			</div>
			<div class="list" v-else>
				<div class="item" v-for="item in couponData.pendingReceiveList" :key="item.id">
					<img class="img" src="@/assets/images/product/coupon_box_bg.png" alt="" />
					<div class="content-info">
						<div class="dot">
							{{ (item.type == 1 && '满减券') || (item.type == 2 && '折扣券') }}
						</div>
						<div class="left">
							<div class="price" v-if="item.type == 1">
								<span style="font-size: 12px">¥</span>
								<span style="font-size: 26px">{{ item.amount }}</span>
							</div>
							<div class="price" v-else-if="item.type == 2">
								<span style="font-size: 26px">{{ item.amount / 10 }}</span>
								<span style="font-size: 12px">折</span>
							</div>
							<div class="condition">满{{ item.minPoint }}元可用</div>
						</div>
						<div class="content">
							<div class="name">{{ item.name }}</div>
							<div class="condition-time">
								<div class="condition">
									{{
			(item.useType == 0 && '全场通用') ||
			(item.useType == 1 && '指定分类可用') ||
			(item.useType == 2 && '指定商品可用')
		}}
								</div>
								<div class="time">
									{{ formatDate(item.startTime, 'yyyy.MM.dd') }} -
									{{ formatDate(item.endTime, 'yyyy.MM.dd') }}
								</div>
							</div>
						</div>
						<div class="right">
							<div class="btn-get" v-if="item.publishCount - item.receiveCount > 0" @click="receiveCoupon(item.id)">
								立即领取
							</div>
							<img v-else class="img" src="@/assets/images/coupon/icon_none.png" alt="" />
						</div>
					</div>
				</div>
			</div>
		</van-action-sheet>

		<!-- 商品确认--弹框 -->
		<van-action-sheet class="sku-sheet-dialog" v-model="skuShow">
			<img class="icon-close" src="@/assets/images/product/icon_close.png" @click="skuShow = false" />
			<div class="h60"></div>
			<div class="goods">
				<img class="goods-img" :src="submitProductForm.selectedSku.pic" />
				<!-- 选择了优惠券 -->
				<div class="price" v-if="submitProductForm.selectedCouponId">
					<span class="symbol">¥</span>
					<span class="num">{{ $roundHalfUp(
			$subtract(
				$multiply(
					submitProductForm.selectedSku.price,
					submitProductForm.quantity
				),
				submitProductForm.selectedCouponAmount
			),
			2
		).split('.')[0] }}</span>
					<span class="small-num">.{{
			$roundHalfUp(
				$multiply(
					submitProductForm.selectedSku.price,
					submitProductForm.quantity
				),
				2
			).split('.')[1]
		}}</span>
				</div>
				<!-- 未选择优惠券 -->
				<div class="price" v-else>
					<span class="symbol">¥</span>
					<span class="num">{{
				$roundHalfUp(
					$multiply(
						submitProductForm.selectedSku.price,
						submitProductForm.quantity
					),
					2
				).split('.')[0]
			}}</span>
					<span class="small-num">.{{
				$roundHalfUp(
					$multiply(
						submitProductForm.selectedSku.price,
						submitProductForm.quantity
					),
					2
				).split('.')[1]
			}}</span>
				</div>
				<div class="old-price">
					商城价 ¥{{
				$accounting.toFixed(submitProductForm.selectedSku.price, 2)
			}}
					<span v-if="submitProductForm.selectedCouponId">
						店铺优惠¥{{
			$accounting.toFixed(submitProductForm.selectedCouponAmount, 2)
		}}
					</span>
				</div>
				<div class="text">已选：{{
				submitProductForm.selectedAttributeDesc
			}}</div>
			</div>
			<!-- 有地址 -->
			<div class="addr" v-if="submitProductForm.selectedReceiveAddressId" @click="addressListShow = !addressListShow">
				<div class="addr-line">
					<span class="c3 m10">{{ submitProductForm.selectedReceiveAddress.name }}</span>
					<span class="c3">{{ submitProductForm.selectedReceiveAddress.tel }}</span>
					<div class="flex1"></div>
				</div>
				<div class="addr-line">
					<img class="icon" src="@/assets/images/product/icon_addr.png" />
					<span class="text f500">{{ submitProductForm.selectedReceiveAddress.address }}</span>
					<div class="flex1"></div>
					<img class="icon-arrow" src="@/assets/images/product/icon_arrow_right.png" />
				</div>
				<div class="addr-line">
					<span class="cg">运费：</span>
					<span class="cbg" v-if="submitProductForm.selectedSkuFreight == 0">包邮</span>
					<span class="cbg" v-else>¥{{
			$accounting.toFixed(submitProductForm.selectedSkuFreight, 2)
		}}</span>
					<div class="flex1"></div>
				</div>
			</div>
			<!-- 无地址 -->
			<div class="addr" v-else @click="showAddReceiveAddressActionSheet">
				<div class="addr-line">
					<img class="icon" src="@/assets/images/product/icon_addr.png" />
					<span class="text">添加收货地址</span>
					<div class="flex1"></div>
					<img class="icon-arrow" src="@/assets/images/product/icon_arrow_right.png" />
				</div>
			</div>

			<!-- <div class="h20"></div> -->

			<div class="spec" v-for="(item, index) in  data.productAttributeList " :key="index">
				<div class="spec-title">{{ item.name }}</div>
				<div class="cont-items">
					<div v-for="itemVal in  item.valueList " :key="itemVal.id" @click="changeProductAttribute(item.name, itemVal)"
						:class="checkSelectedProductAttribute(item.name, itemVal)
			? 'cont-item cont-item-s'
			: 'cont-item'
			">
						{{ itemVal }}
						<!-- <div class="goods-none" v-if="?">
							<img v-if="checkSelectedProductAttribute(item.name, itemVal)" class="icon-none"
								src="@/assets/images/product/icon_goods_none_s.png" />
							<img v-else class="icon-none" src="@/assets/images/product/icon_goods_none.png" />
							<span class="text">售罄</span>
						</div> -->
					</div>
				</div>
			</div>
			<div class="h12"></div>
			<div class="sku-key-val">
				<span class="sku-key">数量</span>
				<div class="flex1"></div>
				<van-stepper class="num-step" v-model="submitProductForm.quantity" input-width="40px" button-size="32px"
					disable-input @change="changeQuantity" />
			</div>
			<div class="sku-key-val" @click="showPendingUseCouponActionSheet">
				<span class="sku-key">店铺优惠券</span>
				<div class="flex1"></div>
				<span class="sku-val red" v-if="(pendingUseCouponData &&
			pendingUseCouponData.enableList &&
			pendingUseCouponData.enableList.length > 0
		) && (submitProductForm.selectedCouponId)">
					减 ¥{{
			$accounting.toFixed(submitProductForm.selectedCouponAmount, 2)
		}}
				</span>
				<span class="sku-val grey" v-else>无可用优惠券</span>
				<img class="icon-arrow" src="@/assets/images/product/icon_arrow_right.png" />
			</div>

			<div class="sku-key-val">
				<span class="sku-key">分期</span>
				<div class="flex1"></div>
				<span class="sku-val green" v-if="data.product.freeTerm">
					支持{{
			data.product.freeTerm.split(',').join('/')
		}}期免息，可在‘下一步’选择期数
				</span>
				<span class="sku-val" v-else>无</span>
			</div>
			<div class="sku-key-val" @click="showRemarkActionSheet">
				<span class="sku-key">备注</span>
				<div class="flex1"></div>
				<span class="sku-val" v-if="submitProductForm.remark">{{ submitProductForm.remark }}</span>
				<span class="sku-val grey" v-else>无备注</span>
				<img class="icon-arrow" src="@/assets/images/product/icon_arrow_right.png" />
			</div>
			<div class="sku-key-val" @click="showBillActionSheet">
				<span class="sku-key">发票</span>
				<div class="flex1"></div>
				<span class="sku-val" v-if="submitProductForm.selectedBillAddressId">电子发票
					<span v-if="submitProductForm.selectedBillAddress.payerType == '1'">(个人)</span>
					<span v-if="submitProductForm.selectedBillAddress.payerType == '2'">(企业)</span>
				</span>
				<span class="sku-val grey" v-else>暂不开具</span>
				<img class="icon-arrow" src="@/assets/images/product/icon_arrow_right.png" />
			</div>

			<div class="h80"></div>
			<div class="next-box">
				<div class="next-step" v-if="submitProductForm.selectedSku.publishCount -
			submitProductForm.selectedSku.useCount -
			submitProductForm.selectedSku.lockStock >
			0
			">
					‘下一步’可使用买单吧红包
				</div>
				<div class="next-btn" @click="next" v-if="submitProductForm.selectedSku.publishCount -
			submitProductForm.selectedSku.useCount -
			submitProductForm.selectedSku.lockStock >
			0
			">
					下一步
				</div>
				<div class="next-btn none" v-else>
					商品已售罄
				</div>
			</div>
		</van-action-sheet>

		<!-- 添加备注--弹框 -->
		<van-action-sheet class="sheet-dialog" v-model="beizhuShow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">添加备注</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="beizhuShow = false" />
			</div>
			<van-field class="remark-box" v-model="remark" rows="4" autosize type="textarea" maxlength="50"
				placeholder="添加备注给商家" show-word-limit>
			</van-field>
			<div class="btn" @click="confirmRemark">确定</div>
		</van-action-sheet>

		<!-- 配送地址--弹框 -->
		<van-action-sheet class="sheet-dialog" v-model="deliverToAddrListShow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">配送地址</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="deliverToAddrListShow = false" />
			</div>
			<div class="addr-list">
				<div @click="changeDeliverToAddr(item.id)"
					:class="submitProductForm.selectedAddrId == item.id ? 'addr-item addr-item-s' : 'addr-item'"
					v-for="item in deliverToData.receiveAddressList" :key="item.id">
					{{ item.address }}
				</div>
			</div>
			<div class="btn" @click="deliverToAreaShow = !deliverToAreaShow">选择其他地址</div>
		</van-action-sheet>

		<!-- 选择所在区域--弹框 -->
		<van-popup v-model="deliverToAreaShow" round position="bottom">
			<van-cascader v-model="submitProductForm.selectedAreaId" active-color="#00754A" title="请选择所在地区"
				:field-names="{ text: 'name', value: 'id', children: 'children' }" :options="deliverToAreaOptions"
				@close="deliverToAreaShow = false" @change="changeDeliverToAreaOption" @finish="finishDeliverToArea" />
		</van-popup>

		<!-- 收货地址列表--弹框 -->
		<van-action-sheet class="sheet-dialog" v-model="addressListShow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">收货地址</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="addressListShow = false" />
			</div>
			<div class="addr-list">
				<div class="addr-list-item" @click="changeReceiveAddress(item.id)"
					v-for="item in deliverToData.receiveAddressList" :key="item.id">
					<div class="name-tel">
						<span class="name">{{ item.name }}</span>
						<span class="tel">{{ item.tel }}</span>
						<span class="tag-b" v-if="item.isDefault == '1'">默认</span>
						<span class="tag" v-if="item.tag == '0'">家</span>
						<span class="tag" v-if="item.tag == '1'">学校</span>
						<span class="tag" v-if="item.tag == '2'">公司</span>
					</div>
					<img class="icon-addr" src="@/assets/images/product/icon_addr.png" />
					<div class="addr-d">{{ item.address }}</div>
					<img class="icon-edit" src="@/assets/images/product/icon_edit.png"
						@click.stop="showEditReceiveAddressActionSheet(item.id)" />
				</div>
			</div>
			<div class="btn" @click="showAddReceiveAddressActionSheet">新增地址</div>
		</van-action-sheet>

		<!-- 新增收货地址--弹框 -->
		<van-action-sheet class="sheet-dialog" v-model="addAddressShow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">{{ submitAddrForm.title }}</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="addAddressShow = false" />
			</div>
			<div class="key-val input-key-val">
				<span class="key">收货人</span>
				<input class="val-input" type="text" v-model="submitAddrForm.name" placeholder="请填写收货人姓名">
			</div>
			<div class="key-val input-key-val">
				<span class="key">手机号码</span>
				<input class="val-input" type="text" v-model="submitAddrForm.phoneNumber" placeholder="请填写手机号码">
			</div>
			<div class="key-val input-key-val">
				<span class="key">所在地区</span>
				<div class="val-input val-input-addr" @click="showReceiveAddressAreaPopup" v-if="submitAddrForm.selectedArea">
					<span class="text-addr">{{ submitAddrForm.selectedArea }}</span>
					<img class="icon-addr-r" src="@/assets/images/product/icon_addr_r.png" />
				</div>
				<div class="val-input val-input-addr" @click="showReceiveAddressAreaPopup" v-else>
					<span class="text-addr grey">省份 城市 地区 街道</span>
					<img class="icon-addr-r" src="@/assets/images/product/icon_addr_r.png" />
				</div>
			</div>
			<div class="key-val input-key-val">
				<span class="key">详细地址</span>
				<input class="val-input" type="text" v-model="submitAddrForm.detailAddress" placeholder="道路、小区、单元室、门牌等">
			</div>
			<div class="key-val input-key-val al">
				<span class="key">标签</span>
				<div class="val-tags">
					<span :class="submitAddrForm.tag == '0' ? 'val-tag val-tag-s' : 'val-tag'"
						@click="changeReceiveAddressTag('0')">家</span>
					<span :class="submitAddrForm.tag == '1' ? 'val-tag val-tag-s' : 'val-tag'"
						@click="changeReceiveAddressTag('1')">学校</span>
					<span :class="submitAddrForm.tag == '2' ? 'val-tag val-tag-s' : 'val-tag'"
						@click="changeReceiveAddressTag('2')">公司</span>
				</div>
			</div>
			<div class="key-val input-key-val">
				<span class="key">设为默认地址</span>
				<img class="icon-default" v-if="submitAddrForm.isDefault == 1" src="@/assets/images/product/icon_default.png"
					@click="submitAddrForm.isDefault = 0" />
				<span class="icon-default-none" v-else @click="submitAddrForm.isDefault = 1"></span>
			</div>
			<div class="btn" @click="submitReceiveAddress">保存</div>
			<van-popup v-model="receiveAddressAreaShow" round position="bottom">
				<van-cascader active-color="#00754A" v-model="submitAddrForm.selectedAreaId" title="请选择所在地区"
					:field-names="{ text: 'name', value: 'id', children: 'children' }" :options="receiveAddressAreaOptions"
					@close="receiveAddressAreaShow = false" @change="changeReceiveAddressAreaOption"
					@finish="finishReceiveAddressArea" />
			</van-popup>
		</van-action-sheet>

		<!-- 店铺优惠券--弹框 -->
		<van-action-sheet class="sheet-dialog" v-model="dianpuyouhuiShow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">店铺优惠券</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="huodongShow = !huodongShow" />
			</div>
			<van-tabs style="margin-top: -15px;" v-model="active" color="#00754A" line-width="10px">
				<van-tab>
					<span slot="title">
						可用优惠券

						<template v-if="pendingUseCouponData && pendingUseCouponData.enableList">
							({{ pendingUseCouponData.enableList.length }})
						</template>

						<template v-else> (0) </template>
					</span>
					<div class="no-more" v-if="!pendingUseCouponData.enableList ||
			pendingUseCouponData.enableList.length === 0">
						<img class="img" src="@/assets/images/coupon/bg_no_more.png" alt="" />
						<span class="tips">抱歉，暂无优惠券呢～</span>
					</div>
					<div class="list coupon-s" v-else>
						<div class="item" v-for="item in pendingUseCouponData.enableList" :key="item.id"
							@click="changePendingUseCoupon(item.couponCode)">
							<img class=" img" src="@/assets/images/product/coupon_box_bg_sm.png" alt="" />
							<div class="content-info">
								<div class="dot">
									{{ (item.coupon.type == 1 && '满减券') || (item.coupon.type == 2 && '折扣券') }}
								</div>
								<div class="left">
									<div class="price" v-if="item.coupon.type == '1'">
										<span style="font-size: 12px">¥</span>
										<span style="font-size: 26px">{{ item.coupon.amount }}</span>
									</div>
									<div class="price" v-else-if="item.coupon.type == 2">
										<span style="font-size: 26px">{{ item.coupon.amount / 10 }}</span>
										<span style="font-size: 12px">折</span>
									</div>
									<div class="condition">满{{ item.coupon.minPoint }}元可用</div>
								</div>
								<div class="content">
									<div class="name">{{ item.coupon.name }}</div>
									<div class="condition-time">
										<div class="condition">
											{{
			(item.coupon.useType == 0 && '全场通用') ||
			(item.coupon.useType == 1 && '指定分类可用') ||
			(item.coupon.useType == 2 && '指定商品可用')
		}}
										</div>
										<div class="time">
											{{ formatDate(item.coupon.startTime, 'yyyy.MM.dd') }} -
											{{ formatDate(item.coupon.endTime, 'yyyy.MM.dd') }}
										</div>
									</div>
								</div>
								<div class="right w60">
									<img v-if="pendingUseCouponId == item.couponCode" class="icon-d"
										src="@/assets/images/product/icon_default.png" alt="" />
									<img v-else class="icon-d" src="@/assets/images/product/icon_default_no.png" alt="" />
								</div>
							</div>
						</div>
					</div>
					<div class="btn" v-if="pendingUseCouponData.enableList && pendingUseCouponData.enableList.length"
						@click="confirmPendingUseCoupon">确定</div>
				</van-tab>
				<van-tab>
					<span slot="title">
						不可用优惠券

						<template v-if="pendingUseCouponData && pendingUseCouponData.disableList">
							({{ pendingUseCouponData.disableList.length }})
						</template>

						<template v-else> (0) </template>
					</span>
					<div class="no-more" v-if="!pendingUseCouponData.disableList ||
			pendingUseCouponData.disableList.length === 0">
						<img class="img" src="@/assets/images/coupon/bg_no_more.png" alt="" />
						<span class="tips">抱歉，暂无优惠券呢～</span>
					</div>
					<div class="list coupon-s" v-else>
						<div class="item coupon-grey" v-for="item in pendingUseCouponData.disableList" :key="item.id"
							@click="changePendingUseCoupon(item.couponCode)">
							<img class=" img" src="@/assets/images/product/coupon_box_bg.png" alt="" />
							<div class="content-info">
								<div class="dot">
									{{ (item.type == 1 && '满减券') || (item.type == 2 && '折扣券') }}
								</div>
								<div class="left">
									<div class="price" v-if="item.coupon.type == '1'">
										<span style="font-size: 12px">¥</span>
										<span style="font-size: 26px">{{ item.coupon.amount }}</span>
									</div>
									<div class="price" v-else-if="item.coupon.type == 2">
										<span style="font-size: 26px">{{ item.coupon.amount / 10 }}</span>
										<span style="font-size: 12px">折</span>
									</div>
									<div class="condition">满{{ item.coupon.minPoint }}元可用</div>
								</div>
								<div class="content">
									<div class="name">{{ item.coupon.name }}</div>
									<div class="condition-time">
										<div class="condition">
											{{
			(item.coupon.useType == 0 && '全场通用') ||
			(item.coupon.useType == 1 && '指定分类可用') ||
			(item.coupon.useType == 2 && '指定商品可用')
		}}
										</div>
										<div class="time">
											{{ formatDate(item.coupon.startTime, 'yyyy.MM.dd') }} -
											{{ formatDate(item.coupon.endTime, 'yyyy.MM.dd') }}
										</div>
									</div>
								</div>
								<div class="right">
									<img class="icon-d" src="@/assets/images/product/icon_default_no.png" alt="" />
								</div>
							</div>
						</div>
					</div>
				</van-tab>
			</van-tabs>
		</van-action-sheet>

		<!-- 发票--弹框 -->
		<van-action-sheet class="sku-sheet-dialog sheet-dialog" v-model="fapiaoShow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">发票类型</div>
				<div class="notice" @click="showFapiaoNotice">发票须知</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="fapiaoShow = false" />
			</div>

			<div class="key-val input-key-val al" style="margin-top: 0;">
				<span class="key">发票类型</span>
				<div class="val-tags">
					<span class="val-tag val-tag-s">电子普通发票</span>
				</div>
			</div>
			<div class="key-val input-key-val al">
				<span class="key">发票抬头</span>
				<div class="val-tags">
					<span :class="confirmBillAddrForm.payerType == '1' ? 'val-tag val-tag-s' : 'val-tag'"
						@click="changeConfirmBillAddressType('1')">个人</span>
					<span :class="confirmBillAddrForm.payerType == '2' ? 'val-tag val-tag-s' : 'val-tag'"
						@click="changeConfirmBillAddressType('2')">公司</span>
				</div>
			</div>
			<section v-if="confirmBillAddrForm.payerType == '1'">
				<div class="key-val input-key-val">
					<span class="key">
						抬头名称<span class="red-x">*</span>
					</span>
					<input class="val-input" v-model="confirmBillAddrForm.payerName" type="text" placeholder="请填写您的姓名">
					<div class="edit-tt" @click="taitouShow = !taitouShow">
						<span class="edit-tt-text">更改抬头</span>
						<img class="edit-tt-icon" src="@/assets/images/product/icon_arrow_right_g.png" />
					</div>
				</div>
				<div class="key-val input-key-val">
					<span class="key">手机号码<span class="red-x">*</span></span>
					<input class="val-input" v-model="confirmBillAddrForm.receiverPhone" type="text" placeholder="请填写手机号码">
				</div>
				<div class="key-val input-key-val">
					<span class="key">邮箱地址<span class="red-x">*</span></span>
					<input class="val-input" v-model="confirmBillAddrForm.receiverEmail" type="text" placeholder="请填写邮箱地址">
				</div>
			</section>
			<section v-else>
				<div class="key-val input-key-val">
					<span class="key">抬头名称<span class="red-x">*</span></span>
					<input class="val-input" v-model="confirmBillAddrForm.payerName" type="text" placeholder="请填写企业名称">
					<div class="edit-tt" @click="taitouShow = !taitouShow">
						<span class="edit-tt-text">更改抬头</span>
						<img class="edit-tt-icon" src="@/assets/images/product/icon_arrow_right_g.png" />
					</div>
				</div>
				<div class="key-val input-key-val">
					<span class="key">税号<span class="red-x">*</span></span>
					<input class="val-input" v-model="confirmBillAddrForm.payerRegisterNo" type="text" placeholder="请填写纳税人识别号">
				</div>
				<div class="key-val input-key-val">
					<span class="key">邮箱地址<span class="red-x">*</span></span>
					<input class="val-input" v-model="confirmBillAddrForm.payerEmail" type="text" placeholder="请填写邮箱地址">
				</div>
				<div class="key-val input-key-val">
					<span class="key">开户银行</span>
					<input class="val-input" v-model="confirmBillAddrForm.payerBank" type="text" placeholder="选填">
				</div>
				<div class="key-val input-key-val">
					<span class="key">银行卡号</span>
					<input class="val-input" v-model="confirmBillAddrForm.payerAccount" type="text" placeholder="选填">
				</div>
				<div class="key-val input-key-val">
					<span class="key">企业电话</span>
					<input class="val-input" v-model="confirmBillAddrForm.payerPhone" type="text" placeholder="选填">
				</div>
				<div class="key-val input-key-val">
					<span class="key">企业地址</span>
					<input class="val-input" v-model="confirmBillAddrForm.payerAddress" type="text" placeholder="选填">
				</div>
			</section>

			<div class="h80"></div>

			<div class="next-box">
				<div class="next-step">
					开票金额具体以最终实付金额为准
				</div>
				<div class="next-btn" @click="confirmBillAddress">
					确定
				</div>
			</div>
		</van-action-sheet>

		<!-- 我的发票抬头--弹框 -->
		<van-action-sheet class="sheet-dialog" v-model="taitouShow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">我的发票抬头</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="taitouShow = false" />
			</div>
			<!---->
			<div class="no-more" v-if="!billAddressList || !billAddressList.length">
				<img class="img" src="@/assets/images/coupon/bg_no_more.png" alt="" />
				<span class="tips">抱歉，暂未添加发票抬头呢～</span>
			</div>
			<div class="tt-list" v-else>
				<div class="tt-list-item" v-for="item in billAddressList" :key="item.id">
					<div class="tt-name-tag">
						<span class="tt-name">{{ item.payerName }}</span>
						<span class="tt-tag">
							{{ item.payerType == '1' ? '个人' : '企业' }}
						</span>
					</div>
					<span class="tt-cont" v-if="item.payerType == '1'">{{ item.receiverEmail }}</span>
					<span class="tt-cont" v-else>税号： {{ item.payerRegisterNo }}</span>
					<div class="tt-btn" @click="useBillAddress(item.id)">使用</div>
					<div class="tt-line"></div>
					<div class="tt-d" @click="changeBillAddressDefault(item.id)">
						<img v-if="item.isDefault == '1'" class="tt-d-icon" src="@/assets/images/product/icon_default.png" alt="" />
						<img v-else class="tt-d-icon" src="@/assets/images/product/icon_default_no.png" alt="" />
						<span class="tt-d-text">{{ item.isDefault == '1' ? '已' : '' }}设为{{ item.payerType == '1' ? '个人' : ''
							}}默认</span>
					</div>
					<img class="tt-icon-edit" @click="showEditBillAddressActionSheet(item.id)"
						src="@/assets/images/product/icon_edit.png" />
					<img class="tt-icon-del" @click="deleteBillAddress(item.id)" src="@/assets/images/product/icon_del.png" />
				</div>
			</div>
			<div class="btn" @click="showAddBillAddressActionSheet">添加发票抬头</div>
		</van-action-sheet>

		<!-- 发票抬头新增/编辑--弹框 -->
		<van-action-sheet class="sku-sheet-dialog sheet-dialog" v-model="addtaitouShow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">{{ submitBillAddrForm.title }}</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="addtaitouShow = false" />
			</div>
			<div class="key-val input-key-val al" style="margin-top: 0;">
				<span class="key">发票抬头</span>
				<div class="val-tags">
					<span :class="submitBillAddrForm.payerType == '1' ? 'val-tag val-tag-s' : 'val-tag'"
						@click="submitBillAddrForm.payerType = '1'">个人</span>
					<span :class="submitBillAddrForm.payerType == '2' ? 'val-tag val-tag-s' : 'val-tag'"
						@click="submitBillAddrForm.payerType = '2'">公司</span>
				</div>
			</div>
			<section v-if="submitBillAddrForm.payerType == '1'">
				<div class="key-val input-key-val">
					<span class="key">
						抬头名称<span class="red-x">*</span>
					</span>
					<input class="val-input" v-model="submitBillAddrForm.payerName" type="text" placeholder="请填写您的姓名">
				</div>
				<div class="key-val input-key-val">
					<span class="key">手机号码<span class="red-x">*</span></span>
					<input class="val-input" v-model="submitBillAddrForm.receiverPhone" type="text" placeholder="请填写手机号码">
				</div>
				<div class="key-val input-key-val">
					<span class="key">邮箱地址<span class="red-x">*</span></span>
					<input class="val-input" v-model="submitBillAddrForm.receiverEmail" type="text" placeholder="请填写邮箱地址">
				</div>
			</section>
			<section v-else>
				<div class="key-val input-key-val">
					<span class="key">抬头名称<span class="red-x">*</span></span>
					<input class="val-input" v-model="submitBillAddrForm.payerName" type="text" placeholder="请填写企业名称">
				</div>
				<div class="key-val input-key-val">
					<span class="key">税号<span class="red-x">*</span></span>
					<input class="val-input" v-model="submitBillAddrForm.payerRegisterNo" type="text" placeholder="请填写纳税人识别号">
				</div>
				<div class="key-val input-key-val">
					<span class="key">邮箱地址<span class="red-x">*</span></span>
					<input class="val-input" v-model="submitBillAddrForm.payerEmail" type="text" placeholder="请填写邮箱地址">
				</div>
				<div class="key-val input-key-val">
					<span class="key">开户银行</span>
					<input class="val-input" v-model="submitBillAddrForm.payerBank" type="text" placeholder="选填">
				</div>
				<div class="key-val input-key-val">
					<span class="key">银行卡号</span>
					<input class="val-input" v-model="submitBillAddrForm.payerAccount" type="text" placeholder="选填">
				</div>
				<div class="key-val input-key-val">
					<span class="key">企业电话</span>
					<input class="val-input" v-model="submitBillAddrForm.payerPhone" type="text" placeholder="选填">
				</div>
				<div class="key-val input-key-val">
					<span class="key">企业地址</span>
					<input class="val-input" v-model="submitBillAddrForm.payerAddress" type="text" placeholder="选填">
				</div>
			</section>
			<div class="key-val input-key-val">
				<span class="key">设为默认抬头</span>
				<img class="icon-default" v-if="submitBillAddrForm.isDefault == 1"
					src="@/assets/images/product/icon_default.png" @click="submitBillAddrForm.isDefault = 0" />
				<span class="icon-default-none" v-else @click="submitBillAddrForm.isDefault = 1"></span>
			</div>
			<div class="btn" @click="submitBillAddress">保存</div>
		</van-action-sheet>

		<MyDialog :dialogForm="dialogForm" />


		<div td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/productDetail" ref="maidian"></div>
	</div>
</template>

<script>
import Swiper from './components/Swiper'
import MyDialog from '@/components/MyDialog.vue'
import { post } from 'api/post'
import { get } from 'api/get'
import CommentList from './pingjiaList'
import Help from '../base/help'
import QuanEmpty2 from '@/assets/images/quanEmpty_2.png'
export default {
	name: 'home',
	components: {
		Swiper,
		CommentList,
		Help,
		MyDialog,
	},
	data() {
		return {
			dialogForm: {
				show: false,
				title: '',
				contentText: '',
				contentTips: '',
				// btnCancelText: '取 消',
				btnConfirmText: '',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
				}
			},
			deliveryNotSupported: false,
			quanEmpty2: QuanEmpty2,
			activeIcon: 'https://img01.yzcdn.cn/vant/user-active.png',
			inactiveIcon: 'https://img01.yzcdn.cn/vant/user-inactive.png',
			activeKey: 0,
			fuwushow: false,
			huodongShow: false,
			kefushow: false,
			fuwushuomingshow: false,
			canshuShow: false,
			cascaderValue: '',
			shuliang: '',
			options: [
				{
					text: '浙江省',
					value: '330000',
					children: [{ text: '杭州市', value: '330100' }],
				},
				{
					text: '江苏省',
					value: '320000',
					children: [{ text: '南京市', value: '320100' }],
				},
			],
			skuShow: false,
			dianpuyouhuiShow: false,
			beizhuShow: false,
			active: 0,
			radio: '',
			fapiaoShow: false,
			fapiaoNoticeShow: false,
			mobileNo: '',
			email: '',
			taitouShow: false,
			qiyeRadio: '',
			addtaitouShow: false,
			fapiaoForm: {
				value: '',
				radio: '1',
			},
			addressListShow: false,
			addAddressShow: false,
			checked: false,
			value: '',
			shop: {
				name: '',
				logo: '',
				invoiceProvideCompany: '',
				customerServicePhone: '',
				customerServiceTime: '',
				onlineServiceTime: '',
				businessLicense: '',
			},
			data: {
				product: {
					id: '',
					name: '',
					pic: '',
					albumPics: '',
					price: '',
					freeTerm: '',
					description: '',
					detailMobileHtml: '',
					category3Code: '',
					minFreeTerm: '', // 最低分期数
					maxFreeTerm: '', // 最高分期数
					freePrice: '', // 最低分期金额
				},
				channelPromotionList: [
					{
						id: '',
						type: '',
						limitAmt: '',
						pic: '',
						linkUrl: '',
					},
				],
				shopPromotionBest: {
					id: '',
					type: '',
					name: '',
					amount: '',
					minPoint: '',
				},
				skuStockList: [
					{
						skuCode: '',
						pic: '',
						spData: '',
						couponAmt: 0,
						channelPntMostCnt: 0,
						channelPntMostDsctAmt: 0,
						guessAmt: 0,
						id: 0,
						skuId: 0,
						price: 0,
						publishCount: 0,
						useCount: 0,
						lowStock: 0,
						lockStock: 0,
						publishId: 0,
					},
				],
				commentCnt: 0,
				commentLimitList: [
					{
						memberIcon: '',
						memberNickName: '',
						content: '',
					},
				],
				productParamList: [
					{
						name: '',
						valueList: [],
					},
				],
				productAttributeList: [
					{
						name: '',
						valueList: [],
					},
				],
			},
			deliverToAddrListShow: false,
			deliverToAreaShow: false,
			deliverToAreaOptions: [],
			deliverToData: {
				receiveAddressList: [],
				area: {
					province: '',
					provinceId: '',
					city: '',
					cityId: '',
					region: '',
					regionId: '',
					street: '',
					streetId: '',
				},
			},
			searchCouponForm: {
				categoryCode: '',
				productId: '',
			},
			couponData: {
				pendingReceiveList: [
					{
						id: '',
						type: '',
						name: '',
						amount: '',
						minPoint: '',
						startTime: '',
						endTime: '',
						useType: '',
						publishCount: 0,
						receiveCount: 0,
					},
				],
				pendingUseList: [
					{
						coupon: {
							id: '',
							type: '',
							name: '',
							amount: '',
							minPoint: '',
							startTime: '',
							endTime: '',
							useType: '',
						},
						categoryRelationList: [],
						productRelationList: [],
					},
				],
			},
			showComment: false,
			showCommentCnt: 0,
			searchProductForm: {
				categoryCode: '',
				channelCode: 'JH001',
				pageNum: 1,
				pageSize: 3,
				sort: '11',
			},
			productData: {
				list: [
					{
						product: {
							id: '',
							name: '',
							pic: '',
							albumPics: '',
							price: '',
							freeTerm: '',
							description: '',
							detailMobileHtml: '',
							category3Code: '',
							maxFreeTerm: '', // 最高分期数
							freePrice: '', // 最低分期金额
						},
					},
				],
				total: 0,
				totalPage: 0,
			},
			receiveAddressAreaShow: false,
			receiveAddressAreaOptions: [],
			submitAddrForm: {
				id: '',
				name: '',
				phoneNumber: '',
				province: '',
				provinceId: '',
				city: '',
				cityId: '',
				region: '',
				regionId: '',
				street: '',
				streetId: '',
				detailAddress: '',
				tag: '',
				isDefault: 0,
				memberId: '',
				postCode: '',
				selectedArea: '',
				selectedAreaId: '',
				title: '新增收货地址',
			},
			pendingUseCouponData: {
				enableList: [],
				disableList: [],
			},
			pendingUseCouponId: '',
			remark: '',
			billAddressList: [],
			confirmBillAddrId: '',
			confirmBillAddrForm: {
				id: '',
				payerType: 1, // 1个人 2企业
				payerName: '', //个人 or 企业
				receiverPhone: '', //个人
				receiverEmail: '', //个人
				payerRegisterNo: '', //税号
				payerEmail: '', //企业邮箱
				payerBank: '', //企业银行
				payerAccount: '', //企业银行卡号
				payerPhone: '', //企业电话
				payerAddress: '', //企业地址
				isDefault: 0,
			},
			submitBillAddrForm: {
				id: '',
				payerType: 1, // 1个人 2企业
				payerName: '', //个人 or 企业
				receiverPhone: '', //个人
				receiverEmail: '', //个人
				payerRegisterNo: '', //税号
				payerEmail: '', //企业邮箱
				payerBank: '', //企业银行
				payerAccount: '', //企业银行卡号
				payerPhone: '', //企业电话
				payerAddress: '', //企业地址
				isDefault: 0,
				title: '添加发票抬头',
			},
			submitProductForm: {
				selectedReceiveAddressId: '', // 选择的收货地址ID
				selectedReceiveAddress: '', // 选择的收货地址
				selectedSkuId: '', // 选择的商品SKU ID
				selectedSku: {
					couponAmt: 0,
					price: 0,
					publishCount: 0,
					useCount: 0,
					lockStock: 0,
				}, // 选择的商品SKU
				selectedAttribute: [{}], // 选择的商品SKU属性
				selectedAttributeDesc: '', // 选择的商品SKU属性描述
				selectedSkuFreight: 0, // 选择的商品SKU对应的运费
				quantity: 1, // 购买的数量
				selectedCouponId: '', // 选择的优惠券 ID
				selectedCoupon: '', // 选择的优惠券
				selectedCouponAmount: 0, // 选择的优惠券金额
				remark: '', //备注
				selectedBillAddressId: '', // 选择的发票抬头 ID
				selectedBillAddress: '', // 选择的发票抬头

				selectedArea: '', // 送至 - 由选择的区域或收货地址, 拼接后的详细地址
				selectedAreaId: '', // 送至 - 选择的区域ID(最后一个区域)
				selectedAddrId: '', // 送至 - 选择的收货地址ID
				freight: 0, // 送至 - 选择的区域或收货地址对应的运费
			},
		}
	},
	mounted() {
		/*this.$refs.test.toggle();*/
	},
	created() {
		if (this.$route.query.publishId) {
			this.getProductDetail(this.$route.query.publishId)
		}

		this.getShopDetail()
		this.getProvince()

		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	watch: {
		'submitProductForm.selectedReceiveAddressId'(val) {
			console.log('watch - submitProductForm.selectedReceiveAddressId: ', val)

			// 发送order/generateConfirmOrder请求计算运费
			// 替换店铺优惠券 - 从order/generateConfirmOrder响应中获取
			this.getFreightWithConfirmOrder()
		},
	},
	methods: {
		showFapiaoNotice() {
			this.dialogForm = {
				show: true,
				title: '发票须知',
				contentText: '',
				contentTips: '1、使用的积分、优惠及手续费部分等，不可开具发票<br /><br />2、发票由商家提供，订单确认收货后10个工作日内开票，如紧急请联系商家客服协助',
				// btnCancelText: '取 消',
				btnConfirmText: '我知道了',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
				}
			}
		},
		getProductDetail(publishId) {
			let self = this
			get('product/detail/' + publishId).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					if (resData.product.freeTerm) {
						let freeTermArray = resData.product.freeTerm.split(',')
						let minFree = freeTermArray[0]

						resData.product.minFreeTerm = minFree
						resData.product.maxFreeTerm =
							freeTermArray[freeTermArray.length - 1]
						// resData.product.freePrice = self.$roundHalfUp(self.$divide(resData.product.price, minFree), 2)
					}

					self.data = resData

					// SKU所需参数
					self.changeProductSku(resData.skuStockList[0].skuId)

					// 相关推荐所需参数
					self.searchProductForm.categoryCode = resData.product.category3Code
					self.getProductList(0)

					// 活动 - 优惠券所需参数
					self.searchCouponForm.categoryCode = resData.product.category3Code
					self.searchCouponForm.productId = resData.product.id

					let parameters = {
						content: [
							{
								action: 'share',
								title: '分享',
								para: {
									channel: 'WX,Wechant',
									desc: '我在买单吧发现了个不错的商品,赶快来看看',
									imageUrl: this.data.product.albumPics.split(',')[0],
									pageUrl: window.location.href,
									title: this.data.product.name,
								},
							},
						],
					}
					srsCallNative('JSNative', parameters, 'JSNativeCallback') //调用原生方法，'JSNativeCallback'为callback调用方法
					window.JSNativeCallback = function (result) { }
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		getShopDetail() {
			let self = this
			get('setting/sysParam/sys_shop_param').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					self.shop.name = resData.find(
						(i) => i.dictLabel == '商城名称'
					).dictValue
					self.shop.logo = resData.find(
						(i) => i.dictLabel == '商城LOGO'
					).dictValue
					self.shop.invoiceProvideCompany = resData.find(
						(i) => i.dictLabel == '发票提供公司'
					).dictValue
					self.shop.customerServicePhone = resData.find(
						(i) => i.dictLabel == '商城客服电话'
					).dictValue
					self.shop.customerServiceTime = resData.find(
						(i) => i.dictLabel == '商城服务时间'
					).dictValue
					self.shop.onlineServiceTime = resData.find(
						(i) => i.dictLabel == '商城在线服务时间'
					).dictValue
					self.shop.businessLicense = resData.find(
						(i) => i.dictLabel == '营业执照'
					).dictValue
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		getProvince() {
			let self = this
			get('area/listProvince').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))
					if (resData && resData.length > 0) {
						resData.forEach((item) => (item.children = []))
						self.deliverToAreaOptions = resData
						self.receiveAddressAreaOptions = JSON.parse(JSON.stringify(resData))
					}
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		changeProductSku(skuId) {
			if (this.submitProductForm.selectedSkuId == skuId) {
				return
			}

			let selectedSku = this.data.skuStockList.find((i) => i.skuId == skuId)

			this.submitProductForm.selectedSkuId = skuId

			// 后续触发事件
			// 主页面
			// 1. 替换商品轮播图中第一个图片
			let albumPics = []
			if (this.data.product.albumPics) {
				albumPics = this.data.product.albumPics.split(',')
				if (selectedSku.pic) {
					albumPics[0] = selectedSku.pic
				}
			} else {
				if (selectedSku.pic) {
					albumPics.push(selectedSku.pic)
				}
			}
			this.data.product.albumPics = albumPics.join(',')

			// 2. 替换商品预估价格
			// 3. 替换最高积分抵扣
			this.submitProductForm.selectedSku = selectedSku

			// 4. 替换选择SKU的规格描述
			this.submitProductForm.selectedAttribute = JSON.parse(selectedSku.spData)
			this.submitProductForm.selectedAttributeDesc =
				this.submitProductForm.selectedAttribute
					.map((i) => i.value)
					.join(', ') +
				', ' +
				this.submitProductForm.quantity +
				'件'

			// SKU弹出页面
			// 1. 替换商品图片
			// 2. 替换商品价格
			// 3. 替换商品规格
		},
		showSkuActionSheet() {
			this.skuShow = !this.skuShow

			if (!this.skuShow) {
				return
			}

			// 发送order/generateConfirmOrder请求计算运费
			// 替换店铺优惠券 - 从order/generateConfirmOrder响应中获取
			this.getFreightWithConfirmOrder()

			this.getReceiveAddressList()
		},
		getReceiveAddressList() {
			let self = this
			get('member/receiveAddress/list').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					if (resData && resData.length > 0) {
						resData.forEach((item) => {
							let address = ''
							if (item.province && item.province != '') {
								address += item.province
							}

							if (item.city && item.city != '') {
								address += item.city
							}

							if (item.region && item.region != '') {
								address += item.region
							}

							if (item.street && item.street != '') {
								address += item.street
							}

							if (item.detailAddress && item.detailAddress != '') {
								address += item.detailAddress
							}

							item.address = address
							item.tel = self.formatTel(item.phoneNumber)
						})

						if (!self.submitProductForm.selectedReceiveAddressId) {
							let defaultAddr = resData.find((item) => item.isDefault == '1')
							if (!defaultAddr) {
								defaultAddr = resData[0]
							}

							self.submitProductForm.selectedReceiveAddressId = defaultAddr.id
							self.submitProductForm.selectedReceiveAddress = defaultAddr
						}

						self.deliverToData.receiveAddressList = resData
					}
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		changeReceiveAddress(id) {
			this.addressListShow = false

			let receiveAddress = this.deliverToData.receiveAddressList.find(
				(i) => i.id == id
			)
			this.submitProductForm.selectedReceiveAddressId = id
			this.submitProductForm.selectedReceiveAddress = receiveAddress
		},
		showAddReceiveAddressActionSheet() {
			this.addAddressShow = !this.addAddressShow

			this.submitAddrForm = {
				id: '',
				name: '',
				phoneNumber: '',
				province: '',
				provinceId: '',
				city: '',
				cityId: '',
				region: '',
				regionId: '',
				street: '',
				streetId: '',
				detailAddress: '',
				tag: '',
				isDefault: 0,
				memberId: '',
				postCode: '',
				selectedArea: '',
				selectedAreaId: '',
				title: '新增收货地址',
			}
		},
		showEditReceiveAddressActionSheet(id) {
			this.addAddressShow = !this.addAddressShow

			let self = this
			get('member/receiveAddress/' + id).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))
					let address = ''
					if (resData.province && resData.province != '') {
						address += resData.province
					}

					if (resData.city && resData.city != '') {
						address += resData.city
					}

					if (resData.region && resData.region != '') {
						address += resData.region
					}

					if (resData.street && resData.street != '') {
						address += resData.street
					}

					self.submitAddrForm = resData
					self.submitAddrForm.selectedArea = address

					self.submitAddrForm.title = '更新收货地址'

					// 用于更新收货地址
					self.backFillReceiveAddressOption(self.submitAddrForm.provinceId, 0)
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		showReceiveAddressAreaPopup() {
			this.receiveAddressAreaShow = true
		},
		changeReceiveAddressAreaOption({ value, tabIndex }) {
			console.log(value)
			console.log(tabIndex)

			// 四级街道直接跳过不查询
			if (tabIndex == 3) {
				return
			}

			let self = this
			get('area/listChild/' + value).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					if (resData && resData.length > 0) {
						// 三级地区的街道不增加children属性
						if (tabIndex < 2) {
							resData.forEach((item) => (item.children = []))
						}

						let selectedOption = self.getSelectedDeliverToAreaOption(
							self.receiveAddressAreaOptions,
							value
						)

						this.$set(selectedOption, 'children', resData)
					}
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		finishReceiveAddressArea({ selectedOptions }) {
			this.receiveAddressAreaShow = false
			this.submitAddrForm.selectedArea = selectedOptions
				.map((option) => option.name)
				.join('')
			for (let i = 0; i < selectedOptions.length; i++) {
				let id = selectedOptions[i].id
				let name = selectedOptions[i].name
				if (i == 0) {
					this.submitAddrForm.province = name
					this.submitAddrForm.provinceId = id
				}
				if (i == 1) {
					this.submitAddrForm.city = name
					this.submitAddrForm.cityId = id
				}
				if (i == 2) {
					this.submitAddrForm.region = name
					this.submitAddrForm.regionId = id
				}
				if (i == 3) {
					this.submitAddrForm.street = name
					this.submitAddrForm.streetId = id
				}
			}
		},
		backFillReceiveAddressOption(value, tabIndex) {
			console.log(value)
			console.log(tabIndex)

			// 四级街道直接跳过不查询
			if (tabIndex == 3) {
				return
			}

			let self = this
			get('area/listChild/' + value).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					if (resData && resData.length > 0) {
						// 三级地区的街道不增加children属性
						if (tabIndex < 2) {
							resData.forEach((item) => (item.children = []))
						}

						let selectedOption = self.getSelectedDeliverToAreaOption(
							self.receiveAddressAreaOptions,
							value
						)

						this.$set(selectedOption, 'children', resData)
					}

					if (
						self.submitAddrForm.province &&
						self.submitAddrForm.province != ''
					) {
						this.$set(
							self.submitAddrForm,
							'selectedAreaId',
							self.submitAddrForm.provinceId
						)
					}

					if (self.submitAddrForm.city && self.submitAddrForm.city != '') {
						this.$set(
							self.submitAddrForm,
							'selectedAreaId',
							self.submitAddrForm.cityId
						)
					}

					if (self.submitAddrForm.region && self.submitAddrForm.region != '') {
						this.$set(
							self.submitAddrForm,
							'selectedAreaId',
							self.submitAddrForm.regionId
						)
					}

					if (self.submitAddrForm.street && self.submitAddrForm.street != '') {
						this.$set(
							self.submitAddrForm,
							'selectedAreaId',
							self.submitAddrForm.streetId
						)
					}

					if (tabIndex == 0 && self.submitAddrForm.cityId) {
						self.backFillReceiveAddressOption(
							self.submitAddrForm.cityId,
							tabIndex + 1
						)
					}

					if (tabIndex == 1 && self.submitAddrForm.regionId) {
						self.backFillReceiveAddressOption(
							self.submitAddrForm.regionId,
							tabIndex + 1
						)
					}

					if (tabIndex == 2 && self.submitAddrForm.streetId) {
						self.backFillReceiveAddressOption(
							self.submitAddrForm.streetId,
							tabIndex + 1
						)
					}
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		changeReceiveAddressTag(val) {
			if (this.submitAddrForm.tag == val) {
				this.submitAddrForm.tag = ''
				return
			}

			this.$set(this.submitAddrForm, 'tag', val)
		},
		submitReceiveAddress() {
			if (!this.submitAddrForm.name) {
				this.$toast('请填写收货人姓名')
				return
			}

			if (!this.submitAddrForm.phoneNumber) {
				this.$toast('请填写11位手机号码')
				return
			}

			// 手机号验证
			const regexp = /^1\d{10}$/
			if (!regexp.test(this.submitAddrForm.phoneNumber)) {
				this.$toast('请填写11位手机号码')
				return
			}

			if (!this.submitAddrForm.selectedArea) {
				this.$toast('请选择所在地区')
				return
			}

			if (!this.submitAddrForm.detailAddress) {
				this.$toast('请填写详细地址')
				return
			}

			let self = this
			let messageText = '创建成功'
			let url = 'member/receiveAddress/add'
			if (self.submitAddrForm.id && self.submitAddrForm.id != '') {
				messageText = '更新成功'
				url = 'member/receiveAddress/update/' + self.submitAddrForm.id
			}
			post(url, this.submitAddrForm).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.$toast(messageText)
					self.addAddressShow = false
					self.getReceiveAddressList()
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		checkSelectedProductAttribute(key, value) {
			let attribute = this.submitProductForm.selectedAttribute.find(
				(a) => a.key == key && a.value == value
			)
			if (attribute) {
				return true
			}

			return false
		},
		changeProductAttribute(key, value) {
			console.log('key : ' + key + ' , value : ' + value)

			let attribute = this.submitProductForm.selectedAttribute.find(
				(a) => a.key == key
			)
			if (attribute && attribute.value == value) {
				// 删除已存在的key-value
				// let index = this.submitProductForm.selectedAttribute.findIndex(a => a.key == key && a.value == value)
				// this.submitProductForm.selectedAttribute.splice(index, 1)
				return
			}

			if (attribute) {
				// 替换已存在的key的value
				attribute.value = value
			} else {
				// 新增key-value
				attribute = {
					key: key,
					value: value,
				}

				this.submitProductForm.selectedAttribute.push(attribute)
			}

			let selectedSkuId = ''
			for (let i = 0; i < this.data.skuStockList.length; i++) {
				let sku = this.data.skuStockList[i]
				let dataArray = JSON.parse(sku.spData)
				let dataCount = 0

				for (let j = 0; j < dataArray.length; j++) {
					let data = dataArray[j]
					let isDataSame = false

					for (
						let m = 0;
						m < this.submitProductForm.selectedAttribute.length;
						m++
					) {
						let attr = this.submitProductForm.selectedAttribute[m]

						if (data.key == attr.key && data.value == attr.value) {
							isDataSame = true
							break
						}
					}

					if (isDataSame) {
						dataCount++
					}
				}

				if (dataCount == dataArray.length) {
					selectedSkuId = sku.skuId
					break
				}
			}

			console.log('selectedSkuId : ' + selectedSkuId)

			// 后续触发事件 - 调用changeProductSku
			if (selectedSkuId) {
				this.changeProductSku(selectedSkuId)

				// 发送order/generateConfirmOrder请求计算运费
				// 替换店铺优惠券 - 从order/generateConfirmOrder响应中获取
				this.getFreightWithConfirmOrder()
			}
		},
		changeQuantity(value) {
			console.log('quantity : ' + value)

			// 替换选择SKU的规格描述
			this.submitProductForm.selectedAttributeDesc =
				this.submitProductForm.selectedAttribute
					.map((i) => i.value)
					.join(', ') +
				', ' +
				this.submitProductForm.quantity +
				'件'

			// 发送order/generateConfirmOrder请求计算运费
			// 替换店铺优惠券 - 从order/generateConfirmOrder响应中获取
			this.getFreightWithConfirmOrder()
		},
		getFreightWithConfirmOrder() {
			if (!this.submitProductForm.selectedReceiveAddressId) {
				console.log('收货地址为空, 终止generateConfirmOrder请求..')
				return
			}

			let data = {
				productId: this.data.product.id,
				categoryCode: this.data.product.category3Code,
				productSkuId: this.submitProductForm.selectedSkuId,
				publishSkuId: this.submitProductForm.selectedSku.id,
				publishId: this.data.product.publishId,
				price: this.submitProductForm.selectedSku.price,
				quantity: this.submitProductForm.quantity,
			}

			let param = {
				province: this.submitProductForm.selectedReceiveAddress.province,
				provinceId: this.submitProductForm.selectedReceiveAddress.provinceId,
			}

			let self = this
			console.log('--------order/generateConfirmOrder---------')
			console.log(this.deliverToData.area.provinceId)
			console.log(data)
			console.log(param)
			console.log('--------order/generateConfirmOrder---------')
			post('order/generateConfirmOrder', data, param).then((res) => {
				console.log('--------order/generateConfirmOrder---------')
				console.log('--------order/generateConfirmOrder---------')
				console.log('--------order/generateConfirmOrder---------')
				console.log('--------order/generateConfirmOrder---------')
				console.log('--------order/generateConfirmOrder---------')
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))
					self.submitProductForm.selectedSkuFreight = resData.freightAmount

					if (!resData.pendingUseCouponResult) {
						this.$set(resData, 'pendingUseCouponResult', {
							enableList: [],
							disableList: [],
						})
					}

					self.pendingUseCouponData = resData.pendingUseCouponResult

					if (
						resData.pendingUseCouponResult &&
						resData.pendingUseCouponResult.enableList &&
						resData.pendingUseCouponResult.enableList.length > 0
					) {
						let selectedCoupon = resData.pendingUseCouponResult.enableList[0]
						self.pendingUseCouponId = selectedCoupon.couponCode
					} else {
						self.pendingUseCouponId = ''
					}
					self.confirmPendingUseCoupon()
					this.deliveryNotSupported = true
				} else {
					this.deliveryNotSupported = false
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		showPendingUseCouponActionSheet() {
			this.dianpuyouhuiShow = !this.dianpuyouhuiShow

			this.pendingUseCouponId = this.submitProductForm.selectedCouponId
		},
		changePendingUseCoupon(val) {
			console.log('pending use coupon : ' + val)

			if (this.pendingUseCouponId == val) {
				this.pendingUseCouponId = ''
				return
			}

			this.pendingUseCouponId = val
		},
		confirmPendingUseCoupon() {
			this.dianpuyouhuiShow = false

			if (this.pendingUseCouponId) {
				let selectedCoupon = this.pendingUseCouponData.enableList.find(
					(i) => i.couponCode == this.pendingUseCouponId
				)

				let selectedCouponAmount = 0
				if (selectedCoupon.coupon.type == '1') {
					selectedCouponAmount = this.$accounting.toFixed(
						selectedCoupon.coupon.amount,
						2
					)
				} else if (selectedCoupon.coupon.type == '2') {
					selectedCouponAmount = this.$roundHalfUp(
						this.$multiply(
							this.submitProductForm.selectedSku.price,
							this.$subtract(1, this.$divide(selectedCoupon.coupon.amount, 100))
						),
						2
					)
				}

				this.submitProductForm.selectedCouponId = this.pendingUseCouponId
				this.submitProductForm.selectedCoupon = selectedCoupon
				this.submitProductForm.selectedCouponAmount = selectedCouponAmount
			} else {
				this.submitProductForm.selectedCouponId = ''
				this.submitProductForm.selectedCoupon = ''
				this.submitProductForm.selectedCouponAmount = 0
			}
		},
		showRemarkActionSheet() {
			this.beizhuShow = !this.beizhuShow

			this.remark = this.submitProductForm.remark
		},
		confirmRemark() {
			this.beizhuShow = false

			if (this.remark) {
				this.submitProductForm.remark = this.remark
			} else {
				this.submitProductForm.remark = ''
			}
		},
		showBillActionSheet() {
			this.fapiaoShow = !this.fapiaoShow

			if (this.submitProductForm.selectedBillAddressId) {
				this.confirmBillAddrId = this.submitProductForm.selectedBillAddressId

				this.confirmBillAddrForm = JSON.parse(
					JSON.stringify(this.submitProductForm.selectedBillAddress)
				)
			} else {
				this.confirmBillAddrId = ''

				this.confirmBillAddrForm = {
					id: '',
					payerType: 1, // 1个人 2企业
					payerName: '', //个人 or 企业
					receiverPhone: '', //个人
					receiverEmail: '', //个人
					payerRegisterNo: '', //税号
					payerEmail: '', //企业邮箱
					payerBank: '', //企业银行
					payerAccount: '', //企业银行卡号
					payerPhone: '', //企业电话
					payerAddress: '', //企业地址
					isDefault: 0,
				}
			}

			this.getBillAddressList()
		},
		getBillAddressList() {
			let self = this
			get('member/billAddress/list').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					if (resData && resData.length > 0) {
						if (!self.confirmBillAddrId) {
							let payerType = self.confirmBillAddrForm.payerType
							if (!payerType) {
								payerType = '1'
							}
							let defaultAddr = resData.find(
								(item) => item.payerType == payerType && item.isDefault == '1'
							)
							if (!defaultAddr) {
								defaultAddr = resData.find(
									(item) => item.payerType == payerType
								)
							}

							if (defaultAddr) {
								self.confirmBillAddrId = defaultAddr.id
								self.confirmBillAddrForm = JSON.parse(
									JSON.stringify(defaultAddr)
								)
							}
						}
					}

					self.billAddressList = resData
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		changeConfirmBillAddressType(type) {
			let defaultAddr = this.billAddressList.find(
				(item) => item.payerType == type && item.isDefault == '1'
			)
			if (!defaultAddr) {
				defaultAddr = this.billAddressList.find(
					(item) => item.payerType == type
				)
			}

			if (defaultAddr) {
				this.confirmBillAddrId = defaultAddr.id
				this.confirmBillAddrForm = JSON.parse(JSON.stringify(defaultAddr))
			} else {
				this.confirmBillAddrId = ''
				this.confirmBillAddrForm = {
					id: '',
					payerType: type, // 1个人 2企业
					payerName: '', //个人 or 企业
					receiverPhone: '', //个人
					receiverEmail: '', //个人
					payerRegisterNo: '', //税号
					payerEmail: '', //企业邮箱
					payerBank: '', //企业银行
					payerAccount: '', //企业银行卡号
					payerPhone: '', //企业电话
					payerAddress: '', //企业地址
					isDefault: 0,
					title: '添加发票抬头',
				}
			}
		},
		confirmBillAddress() {
			if (!this.validateBillAddress(this.confirmBillAddrForm)) {
				return
			}

			let self = this
			let url = 'member/billAddress/add'
			if (self.confirmBillAddrForm.id && self.confirmBillAddrForm.id != '') {
				let existAddr = self.billAddressList.find(
					(item) => item.id == self.confirmBillAddrForm.id
				)
				if (existAddr) {
					url = 'member/billAddress/update/' + self.confirmBillAddrForm.id
				} else {
					self.confirmBillAddrForm.id = ''
				}
			}
			if (this.confirmBillAddrForm.payerName.indexOf('交通银行') > -1) {
				self.$toast('该名称不可用，请重新输入')
				return
			}

			post(url, this.confirmBillAddrForm).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.fapiaoShow = false

					get('member/billAddress/list').then((res) => {
						console.log(res)
						if (res.code === self.GLOBAL.SUCCESS) {
							let resData = JSON.parse(JSON.stringify(res.data))

							if (
								self.confirmBillAddrForm.id &&
								self.confirmBillAddrForm.id != ''
							) {
								// 更新抬头
								let billAddress = resData.find(
									(i) => i.id == self.confirmBillAddrForm.id
								)

								self.submitProductForm.selectedBillAddressId = billAddress.id
								self.submitProductForm.selectedBillAddress = JSON.parse(
									JSON.stringify(billAddress)
								)
							} else {
								// 新增抬头
								let payerType = self.confirmBillAddrForm.payerType
								if (!payerType) {
									payerType = '1'
								}
								let defaultAddr = resData.find(
									(item) => item.payerType == payerType && item.isDefault == '1'
								)
								if (!defaultAddr) {
									defaultAddr = resData.find(
										(item) => item.payerType == payerType
									)
								}

								self.submitProductForm.selectedBillAddressId = defaultAddr.id
								self.submitProductForm.selectedBillAddress = JSON.parse(
									JSON.stringify(defaultAddr)
								)
							}

							self.billAddressList = resData
						} else {
							self.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#f2250f',
							})
						}
					})
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		showAddBillAddressActionSheet() {
			this.addtaitouShow = !this.addtaitouShow

			this.submitBillAddrForm = {
				id: '',
				payerType: 1, // 1个人 2企业
				payerName: '', //个人 or 企业
				receiverPhone: '', //个人
				receiverEmail: '', //个人
				payerRegisterNo: '', //税号
				payerEmail: '', //企业邮箱
				payerBank: '', //企业银行
				payerAccount: '', //企业银行卡号
				payerPhone: '', //企业电话
				payerAddress: '', //企业地址
				isDefault: 0,
				title: '添加发票抬头',
			}
		},
		showEditBillAddressActionSheet(id) {
			this.addtaitouShow = !this.addtaitouShow

			let self = this
			get('member/billAddress/' + id).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.submitBillAddrForm = JSON.parse(JSON.stringify(res.data))

					self.submitBillAddrForm.title = '更新发票抬头'
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		validateBillAddress(data) {
			if (data.payerType == '1') {
				if (!data.payerName) {
					this.$toast('请输入您的姓名')
					return false
				}

				if (!data.receiverPhone) {
					this.$toast('请输入手机号码')
					return false
				}

				if (!data.receiverEmail) {
					this.$toast('请输入邮箱地址')
					return false
				}
			}

			if (data.payerType == '2') {
				if (!data.payerName) {
					this.$toast('请输入企业名称')
					return false
				}

				if (!data.payerRegisterNo) {
					this.$toast('请输入纳税人识别号')
					return false
				}

				if (!data.payerEmail) {
					this.$toast('请输入邮箱地址')
					return false
				}
			}

			return true
		},
		submitBillAddress() {
			if (!this.validateBillAddress(this.submitBillAddrForm)) {
				return
			}

			let self = this
			let messageText = '创建成功'
			let url = 'member/billAddress/add'
			if (self.submitBillAddrForm.id && self.submitBillAddrForm.id != '') {
				messageText = '更新成功'
				url = 'member/billAddress/update/' + self.submitBillAddrForm.id
			}
			if (this.submitBillAddrForm.payerName.indexOf('交通银行') > -1) {
				self.$toast('该名称不可用，请重新输入')
				return
			}
			post(url, this.submitBillAddrForm).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.$toast(messageText)
					self.addtaitouShow = false
					self.getBillAddressList()
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		useBillAddress(id) {
			this.taitouShow = false

			let billAddress = this.billAddressList.find((i) => i.id == id)
			this.confirmBillAddrId = id
			this.confirmBillAddrForm = JSON.parse(JSON.stringify(billAddress))
		},
		changeBillAddressDefault(id) {
			let self = this
			get('member/billAddress/' + id).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))
					if (resData.isDefault == '1') {
						resData.isDefault = '0'
					} else {
						resData.isDefault = '1'
					}

					post('member/billAddress/update/' + resData.id, resData).then(
						(res) => {
							console.log(res)
							if (res.code === self.GLOBAL.SUCCESS) {
								self.$toast('操作成功')
								self.getBillAddressList()
							} else {
								self.$dialog.alert({
									theme: 'round-button',
									message: res.message,
									confirmButtonColor: '#f2250f',
								})
							}
						}
					)
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		deleteBillAddress(id) {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '确定删除该条记录吗？',
				btnCancelText: '暂不删除',
				btnConfirmText: '确定',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					get('member/billAddress/delete/' + id).then((res) => {
						console.log(res)
						if (res.code === self.GLOBAL.SUCCESS) {
							self.$toast('刪除成功')
							self.getBillAddressList()
						} else {
							self.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#f2250f',
							})
						}
					})
				}
			}
		},
		getDeliverToList() {
			let self = this

			get('member/receiveAddress/list').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					if (resData && resData.length > 0) {
						resData.forEach((item) => {
							let address = ''
							if (item.province && item.province != '') {
								address += item.province
							}

							if (item.city && item.city != '') {
								address += item.city
							}

							if (item.region && item.region != '') {
								address += item.region
							}

							if (item.street && item.street != '') {
								address += item.street
							}

							if (item.detailAddress && item.detailAddress != '') {
								address += item.detailAddress
							}

							item.address = address
						})

						self.deliverToData.receiveAddressList = resData
						self.deliverToAddrListShow = true
					} else {
						self.deliverToAreaShow = true
					}
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		getSelectedDeliverToAreaOption(options, value) {
			for (let i = 0; i < options.length; i++) {
				let option = options[i]
				if (option.id == value) {
					return option
				}

				if (option.children && option.children.length > 0) {
					option = this.getSelectedDeliverToAreaOption(option.children, value)
					if (option && option.id == value) {
						return option
					}
				}
			}

			return null
		},
		changeDeliverToAreaOption({ value, tabIndex }) {
			console.log(value)
			console.log(tabIndex)

			// 四级街道直接跳过不查询
			if (tabIndex == 3) {
				return
			}

			let self = this
			get('area/listChild/' + value).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					if (resData && resData.length > 0) {
						// 三级地区的街道不增加children属性
						if (tabIndex < 2) {
							resData.forEach((item) => (item.children = []))
						}

						let selectedOption = self.getSelectedDeliverToAreaOption(
							self.deliverToAreaOptions,
							value
						)

						this.$set(selectedOption, 'children', resData)
					}
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		finishDeliverToArea({ selectedOptions }) {
			this.deliverToAreaShow = false
			this.deliverToAddrListShow = false
			this.submitProductForm.selectedArea = selectedOptions
				.map((option) => option.name)
				.join('')
			this.submitProductForm.selectedAddrId = ''
			for (let i = 0; i < selectedOptions.length; i++) {
				let id = selectedOptions[i].id
				let name = selectedOptions[i].name
				if (i == 0) {
					this.deliverToData.area.province = name
					this.deliverToData.area.provinceId = id
				}
				if (i == 1) {
					this.deliverToData.area.city = name
					this.deliverToData.area.cityId = id
				}
				if (i == 2) {
					this.deliverToData.area.region = name
					this.deliverToData.area.regionId = id
				}
				if (i == 3) {
					this.deliverToData.area.street = name
					this.deliverToData.area.streetId = id
				}
			}

			this.calculateFreight(1, this.deliverToData.area.province, this.deliverToData.area.provinceId)
		},
		changeDeliverToAddr(id) {
			if (!id) {
				return
			}

			let receiveAddress = this.deliverToData.receiveAddressList.find(
				(i) => i.id == id
			)

			this.deliverToAreaShow = false
			this.deliverToAddrListShow = false
			this.submitProductForm.selectedAddrId = id
			this.submitProductForm.selectedArea = receiveAddress.address
			this.submitProductForm.selectedAreaId = ''

			this.calculateFreight(1, receiveAddress.province, receiveAddress.provinceId)
		},
		calculateFreight(qty, province, provinceId) {
			let self = this
			let form = {
				qty: qty,
				province,
				provinceId, // 所在省ID 【新增】
				productId: this.data.product.id, // 商品ID 【新增】

			}
			get('order/calculateFreight', form).then((res) => {
				console.log('******************')
				console.log('******************')
				console.log('******************')
				console.log('******************')
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.submitProductForm.freight = JSON.parse(JSON.stringify(res.data))
					this.deliveryNotSupported = false
				} else {
					this.deliveryNotSupported = true
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		checkChannelPromotionExist(data, type) {
			if (!data.channelPromotionList || data.channelPromotionList.length < 1) {
				return false
			}

			return data.channelPromotionList.find((i) => i.type == type)
		},
		getChannelPromotionDesc(data) {
			if (!data.channelPromotionList || data.channelPromotionList.length < 1) {
				return ''
			}

			let promotion = data.channelPromotionList.find((i) => i.type == '1')

			if (promotion) {
				return promotion.limitAmt + '%'
			}

			return ''
		},
		getShopPromotionAmount(data) {
			if (!data.shopPromotionBest) {
				return ''
			}

			if (data.shopPromotionBest.type == '1') {
				return this.$accounting.toFixed(data.shopPromotionBest.amount, 2)
			} else if (data.shopPromotionBest.type == '2') {
				return this.$roundHalfUp(
					this.$multiply(
						data.product.price,
						this.$subtract(1, this.$divide(data.shopPromotionBest.amount, 100))
					),
					2
				)
			}

			return ''
		},
		getShopPromotionDesc(data) {
			if (!data.shopPromotionBest) {
				return ''
			}

			if (data.shopPromotionBest.type == '1') {
				return (
					'满' +
					data.shopPromotionBest.minPoint +
					'减' +
					data.shopPromotionBest.amount
				)
			} else if (data.shopPromotionBest.type == '2') {
				return (
					'满' +
					data.shopPromotionBest.minPoint +
					'打' +
					data.shopPromotionBest.amount / 10 +
					'折'
				)
			}

			return ''
		},
		getProductParamDesc(data) {
			if (!data.productParamList) {
				return ''
			}

			let array = []
			for (let i = 0; i < data.productParamList.length; i++) {
				if (i > 2) {
					break
				}

				array.push(data.productParamList[i].name)
			}

			return array.join(' ')
		},
		getCouponList() {
			let self = this
			self.huodongShow = !self.huodongShow

			if (!self.huodongShow) {
				return
			}

			get('coupon/listByProduct', self.searchCouponForm).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.couponData = JSON.parse(JSON.stringify(res.data))
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		formatNickName(name) {
			if (!name) {
				return ''
			}

			let searchValue = /(.{1}).*(.{1})/
			let replaceValue = '$1***$2'
			if (name.length < 2) {
				searchValue = /(.{1}).*/
				replaceValue = '$1***'
			}

			return name.replace(searchValue, replaceValue)
		},
		formatTel(tel) {
			if (!tel) {
				return ''
			}
			return tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
		},
		formatDate: function (datestr, fmt) {
			let date = new Date(Date.parse(datestr.substring(0, 10)))

			if (/(y+)/.test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1,
					(date.getFullYear() + '').substr(4 - RegExp.$1.length)
				)
			}
			let o = {
				'M+': date.getMonth() + 1,
				'd+': date.getDate(),
				'h+': date.getHours(),
				'm+': date.getMinutes(),
				's+': date.getSeconds(),
			}
			for (let k in o) {
				if (new RegExp(`(${k})`).test(fmt)) {
					let str = o[k] + ''
					fmt = fmt.replace(
						RegExp.$1,
						RegExp.$1.length === 1 ? str : this.padLeftZero(str)
					)
				}
			}
			return fmt
		},
		padLeftZero: function (str) {
			return ('00' + str).substr(str.length)
		},
		receiveCoupon(id) {
			let self = this
			post('coupon/userReceiveCoupon/' + id).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.$toast('领取成功')
					self.getCouponList()
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		useCoupon(item) {
			console.log('item.coupon.useType : ' + item.coupon.useType)

			if (item.coupon.useType == '0') {
				this.$router.push('/productlsit')
			} else if (item.coupon.useType == '1') {
				let categoryCodeList = item.categoryRelationList.map(
					(i) => i.category3Code
				)
				this.$router.push({
					path: '/productlsit',
					query: { categoryCodeList: JSON.stringify(categoryCodeList) },
				})
			} else if (item.coupon.useType == '2') {
				let productIdList = item.productRelationList.map((i) => i.productId)
				this.$router.push({
					path: '/productlsit',
					query: { productIdList: JSON.stringify(productIdList) },
				})
			}
		},
		gotoLinkUrl(data, type) {
			window.location.href = this.checkChannelPromotionExist(data, type).linkUrl
		},
		getProductList(index) {
			console.log('index : ' + index)
			let self = this
			self.searchProductForm.pageNum = index + 1
			post('product/search', self.searchProductForm).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.productData = JSON.parse(JSON.stringify(res.data))
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		gotoProductDetail(publishId) {
			// 此处跳转不起作用
			this.$router.push({
				path: '/productDetail',
				query: { publishId: publishId },
			})
			this.$router.go(0)

			/*let routeUrl = this.$router.resolve({
										path: '/productDetail',
										query: {publishId: publishId}
								});
								window.open(routeUrl.href, '_blank');*/
		},
		next() {
			if (!this.submitProductForm.selectedReceiveAddressId) {
				this.$toast('请选择收货地址')
				return
			}

			let body = {
				item: {
					productId: this.data.product.id,
					categoryCode: this.data.product.category3Code,
					productSkuId: this.submitProductForm.selectedSkuId,
					publishSkuId: this.submitProductForm.selectedSku.id,
					publishId: this.data.product.publishId,
					price: this.submitProductForm.selectedSku.price,
					quantity: this.submitProductForm.quantity,
				},
			}

			body.receiveAddressId = this.submitProductForm.selectedReceiveAddressId

			if (this.submitProductForm.selectedCouponId) {
				body.couponCode = this.submitProductForm.selectedCoupon.couponCode
			}

			body.note = this.submitProductForm.remark

			if (this.submitProductForm.selectedBillAddressId) {
				body.billCategory = '1'
				body.billAddressId = this.submitProductForm.selectedBillAddressId
			}

			let self = this
			post('order/generateOrder', body, {}, true).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					window.location.href = resData
				} else if (res.code == '412') {
					self.$dialog.alert({
						theme: 'round-button',
						title: res.message,
						message: res.data,
						confirmButtonColor: '#f2250f',
					})
				}
			})
		},
		buy() {
			this.$router.push('/payResult')
		},
		onClickLeft() {
			window.history.back()
		},
		test1() {
			console.log(111)
		},
		test2() {
			console.log(222)
		},
		gotoComment() {
			this.$router.push({
				path: '/pingjiaList',
				query: { productId: this.data.product.id },
			})
		},
		goHome() {
			this.$router.push('/')
		},
		showKefu() {
			this.kefushow = !this.kefushow
		},
		phoneNumber() {
			window.location.href = 'tel://' + this.shop.customerServicePhone
		},
		phoneNumber2() {
			// window.location.href = this.$baseUrl3
			// this.$router.push("/help");
			// this.$refs.content3.click();
			document.getElementById('content').click()
		},
	},
}
</script>

<style>
.overwrite_productDetail .van-swipe__indicators {
	bottom: 5px;
}

.detal_choose .van-cell__value {
	font-size: 1.3rem;
}

.dianpu .van-cell__value {
	font-size: 1.3rem;
}

.overwrite_productDetail .van-field__control {
	background: #f7f8fa !important;
}

.addtaitou_box .van-field__control {
	background: #ffffff !important;
}

.addtaitou_box .van-cell-group--inset {
	margin: 0;
}

.sku_content_box .van-cell {
	padding: 4px 16px;
}

.sku_content_box .van-field__control {
	background: #ffffff !important;
}

.over_write_img img {
	width: 100vw;
}

.over_write_title .van-cell__title {
	font-size: 1.5rem;
	font-family: 'siyuan';
}

.over_write_title .van-cell--large .van-cell__label {
	padding-top: 10px;
}

.detal_choose .van-cell__title {
	font-family: 'siyuan';
	font-size: 1.3rem;
}

.detal_choose .van-cell__label {
	font-size: 1rem;
	font-family: 'siyuan2';
	color: #646566;
}

.overwrite_productDetail .van-action-sheet__header {
	background: #fff !important;
}
</style>

<style lang="less" scoped>
/deep/.van-tabs__line {
	bottom: 22px;
}

.detail-page {
	background: #f7f7f7;
}

.discount-info {
	margin: 12px auto 0;
	width: 355px;
	height: 107px;
	background: url('../../assets/images/product/bg_discount_info.png') center center no-repeat;
	background-size: 100% 100%;

	.line-one {
		box-sizing: border-box;
		padding: 10px 12px 6px;
		color: #ffffff;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.price-box {
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: flex-end;

			.symbol {
				height: 18px;
				font-size: 15px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				line-height: 18px;
			}

			.price-big {
				height: 26px;
				font-size: 26px;
				font-family: 'DINA';
				font-weight: bold;
				line-height: 26px;
			}

			.price-small {
				font-size: 20px;
				font-family: 'DINA';
			}
		}

		.text-bg {
			margin-left: 6px;
			box-sizing: border-box;
			padding: 4px 10px;
			background: url('../../assets/images/product/bg_discount_info_text.png') center center no-repeat;
			background-size: 100% 100%;
			width: 74px;
			height: 22px;
			font-size: 11px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #00754a;
			white-space: nowrap;
		}

		.text {
			flex: 1;
			text-align: right;
			height: 14px;
			font-size: 12px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #ffffff;
			line-height: 14px;
		}
	}

	.line-two {
		box-sizing: border-box;
		margin: 0 auto;
		padding: 0 6px;
		width: 331px;
		height: 22px;
		background: url('../../assets/images/product/bg_discount_info_line-two.png') center center no-repeat;
		background-size: 100% 100%;
		font-size: 10px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #ffffff;
		line-height: 22px;
	}
}

.title-info {
	box-sizing: border-box;
	margin: -34px auto 0;
	padding: 12px;
	width: 355px;
	height: 119px;
	background: #ffffff;
	border-radius: 11px;

	.price-info {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.price {
			flex: 1;
			height: 16px;
			font-size: 13px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #333333;
		}

		.tag {
			margin-right: 4px;
		}

		.text {
			font-size: 13px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #333333;
		}

		.red {
			color: #ff4e4e;
		}
	}

	.tag {
		margin-right: 10px;
		padding: 0 4px;
		height: 18px;
		line-height: 18px;
		text-align: center;
		background: rgba(255, 78, 78, 0.06);
		border-radius: 4px;
		font-size: 11px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #ff4e4e;
	}

	.coupons-info {
		margin-top: 11px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.coupons-tag {
			flex: 1;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: flex-start;
			align-items: center;
		}

		.coupons-btn {
			width: 48px;
			height: 20px;
			background: #00754a;
			border-radius: 6px;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;

			.btn-text {
				margin-right: 4px;
				font-size: 11px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				color: #ffffff;
			}

			.img {
				width: 12px;
				height: 12px;
			}
		}
	}

	.title {
		margin-top: 10px;
		font-size: 15px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 20px;
	}
}

.box {
	box-sizing: border-box;
	margin: 10px auto;
	width: 355px;
	background: #ffffff;
	border-radius: 11px;
}

.specifications-info {
	padding: 12px;

	.line {
		padding: 10px 0;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.key {
			margin-right: 20px;
			font-size: 13px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #666666;
		}

		.value {
			flex: 1;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: flex-end;
			align-items: center;

			.text {
				font-size: 13px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #333333;
				max-width: 260px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.grey {
				font-size: 13px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #cccccc;
			}

			.img {
				margin-left: 2px;
				width: 12px;
				height: 12px;
			}
		}
	}

	.items {
		max-width: 260px;
		padding-left: 70px;
		display: flex;
		justify-content: flex-end;

		.guige_box {
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: flex-end;
			align-items: center;

			.guige_box_item {
				margin: 0 5px;
				position: relative;

				.sell-out {
					width: 28px;
					height: 16px;
					background: #999999;
					border-radius: 4px;
					font-size: 10px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #FFFFFF;
					line-height: 16px;
					text-align: center;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
				}
			}
		}
	}

	.freight {
		margin-top: -4px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: flex-end;
		align-items: center;

		.freight-key {
			height: 14px;
			font-size: 11px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #00754A;
			line-height: 14px;
		}

		.freight-val {
			box-sizing: border-box;
			padding: 1px 4px;
			height: 16px;
			line-height: 14px;
			text-align: center;
			background: #00754A;
			border-radius: 4px;
			font-size: 11px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
		}

	}
}

.goods-evaluate {
	padding: 0 12px;

	.title-line {
		min-height: 50px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.text {
			font-size: 15px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #333333;
		}

		.num {
			font-size: 12px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #333333;
		}

		.flex1 {
			flex: 1;
		}

		.text-all {
			font-size: 11px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #999999;
		}

		.img {
			margin-left: 2px;
			width: 12px;
			height: 12px;
		}
	}

	.evaluate-list {
		.evaluate-item {
			border-bottom: 1px solid #EEEEEE;
			padding: 12px 0;

			.img-name {
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: flex-start;
				align-items: center;

				.img {
					margin-right: 8px;
					width: 24px;
					height: 24px;
					border-radius: 50%;
				}

				.name {
					height: 14px;
					font-size: 12px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #333333;
					line-height: 14px;
				}

			}

			.content {
				margin: 8px 0 0;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
				font-size: 12px;
				color: #333333;
			}
		}

		.evaluate-item:last-child {
			border-bottom: none;
			padding-bottom: 12px;
		}
	}


}

.shop-info {
	padding: 0 12px;
	min-height: 58px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: center;
	align-items: center;

	.logo {
		margin-right: 10px;
		width: 34px;
		height: 34px;
		border-radius: 4px;
	}

	.text {
		font-size: 13px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		color: #333333;
	}

	.flex1 {
		flex: 1;
	}

	.text-all {
		font-size: 11px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #999999;
	}

	.img {
		margin-left: 2px;
		width: 12px;
		height: 12px;
	}
}

.recommend-info {
	padding: 12px 12px 0;

	.title {
		height: 18px;
		font-size: 15px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 18px;
	}

	.goods-swiper {
		margin-top: 10px;
		padding-bottom: 16px;

		.goods-swiper-item {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: flex-start;
			width: 100%;
			box-sizing: border-box;

			.goods-item {
				width: 104px;
				margin-right: 8px;

				.img {
					width: 104px;
					height: 104px;
					border-radius: 6px;
					overflow: hidden;
				}

				.name {
					margin: 6px 0 4px;
					padding: 0 4px;
					width: 100%;
					font-size: 12px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #333333;
					height: 32px;
					line-height: 16px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
				}

				.price {
					font-size: 0;

					.symbol {
						font-size: 13px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #FF4E4E;
					}

					.num {
						font-size: 18px;
						font-family: 'DINA';
						font-weight: bold;
						color: #FF4E4E;
					}

					.text {
						font-size: 12px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
					}
				}
			}

			.goods-item:nth-child(3n) {
				margin: 0;
			}
		}

		/deep/ .van-swipe__indicators {
			bottom: 4px;

			.van-swipe__indicator {
				width: 4px;
				height: 2px;
				background: rgba(0, 117, 74, 0.44);
				border-radius: 2px;

			}

			.van-swipe__indicator:not(:last-child) {
				margin-right: 2px;
			}

			.van-swipe__indicator--active {
				width: 7px;
				height: 2px;
				background: #00754A;
				border-radius: 2px;
			}
		}
	}

}

.goods-detail {
	margin: 24px 0 19px;
	height: 18px;
	line-height: 18px;
	position: relative;

	.img {
		width: 200px;
		height: 10px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.text {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #333333;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}

.bottom-btn {
	padding: 5px 10px 5px 12px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: center;
	align-items: center;

	.btn {
		margin: 0 8px;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.icon {
			width: 24px;
			height: 24px;
			margin-bottom: 3px;
		}

		.text {
			height: 12px;
			font-size: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #666666;
			line-height: 12px;
		}
	}

	.flex1 {
		flex: 1;
	}

	.buy {
		width: 261px;
		height: 40px;
		background: #00754A;
		border-radius: 10px;
		font-size: 15px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
	}

	.grey {
		background: #CCCCCC;
	}
}

.sheet-dialog {
	box-sizing: border-box;
	padding: 46px 15px 12px;

	.sheet-title {
		background-color: #fff;
		position: absolute;
		top: 12px;
		left: 0;
		width: 100%;
		box-sizing: border-box;
		padding: 0 15px 12px 15px;
		height: 30px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: space-between;
		align-items: center;
		z-index: 1;

		.flex {
			width: 12px;
			height: 12px;
		}

		.text {
			height: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #333333;
			line-height: 18px;
			text-align: center;
			font-style: normal;
		}

		.notice {
			position: absolute;
			top: 0;
			right: 39px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #00754A;
		}

		.icon {
			width: 12px;
			height: 12px;
		}
	}

	.key-val {
		margin: 16px 0;
		padding: 0 2px;
		min-height: 16px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: space-between;
		align-items: flex-start;

		.key {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #666666;
			line-height: 16px;
		}

		.val {
			text-align: right;
			width: 240px;
			line-height: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #333333;
		}



		.img {
			width: 149px;
		}
	}

	.input-key-val {
		align-items: center;
		height: 40px;
		position: relative;

		.key {
			width: 80px;

			.red-x {
				color: #FF4E4E;
				font-size: 13px;
			}
		}

		.val-input {
			box-sizing: border-box;
			padding: 12px;
			flex: 1;
			border: none;
			height: 40px;
			line-height: 40px;
			background: #F7F7F7;
			border-radius: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #333333;

			.text-addr {
				height: 40px;
				line-height: 40px;
				width: 220px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333;
			}

			.icon-addr-r {
				width: 14px;
				height: 14px;
			}

			.grey {
				color: #CCCCCC;
			}
		}

		.val-input::placeholder {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #CCCCCC;
		}

		.val-input-addr {
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;
		}

		.edit-tt {
			position: absolute;
			top: 14px;
			right: 12px;
			display: flex;
			align-content: center;
			justify-content: center;
			align-items: center;

			.edit-tt-text {
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #00754A;
				line-height: 14px;
			}

			.edit-tt-icon {
				width: 12px;
				height: 12px;
			}

		}

		.val-tags {
			.val-tag {
				margin-right: 10px;
				height: 28px;
				line-height: 28px;
				box-sizing: border-box;
				padding: 12px;
				background: #F7F7F7;
				border-radius: 10px;
				font-weight: 400;
				font-size: 13px;
				color: #999;
			}

			.val-tag-s {
				background: rgba(0, 117, 74, 0.06);
				color: #00754A;
			}
		}

		.icon-default {
			width: 16px;
			height: 16px;
		}

		.icon-default-none {
			box-sizing: border-box;
			width: 16px;
			height: 16px;
			background: #FFFFFF;
			border-radius: 4px;
			border: 1px solid #EEEEEE;
		}
	}

	.al {
		justify-content: flex-start
	}


	.icon-val {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 5px;

		.icon {
			width: 16px;
			height: 16px;
			margin-right: 6px;
		}

		.val {
			height: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #00754A;
			line-height: 18px;
		}
	}

	.explain {
		width: 345px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 12px;
		color: #666666;
		line-height: 16px;
		margin-bottom: 90px;
	}

	.remark-box {
		background: #F7F7F7;
		border-radius: 10px;
	}

	.addr-list {
		max-height: 350px;
		padding-bottom: 30px;
		overflow: auto;

		.addr-item {
			box-sizing: border-box;
			margin: 0 auto 10px;
			padding: 9px 10px;
			width: 345px;
			background: #F7F7F7;
			border-radius: 6px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #333333;
			line-height: 16px;
		}

		.addr-item-s {
			color: #00754A;
			border: 1px solid #00754A;
			background: rgba(0, 117, 74, 0.06);
		}

		.addr-list-item {
			box-sizing: border-box;
			margin: 0 auto 10px;
			width: 345px;
			height: 60px;
			background: #F7F7F7;
			border-radius: 10px;
			position: relative;

			.name-tel {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 13px;
				color: #333333;
				line-height: 16px;
				position: absolute;
				top: 12px;
				left: 12px;

				.tel {
					margin-left: 10px;
					font-weight: 400;
				}

				.tag-b {
					margin: 0 6px 0 10px;
					padding: 0 4px;
					height: 16px;
					background: #00754A;
					border-radius: 4px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #FFFFFF;
					line-height: 16px;
				}

				.tag {
					padding: 0 4px;
					height: 16px;
					background: rgba(0, 117, 74, 0.06);
					border-radius: 4px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #00754A;
					line-height: 16px;
				}
			}

			.icon-addr {
				width: 14px;
				height: 14px;
				position: absolute;
				top: 34px;
				left: 12px;
			}

			.addr-d {
				position: absolute;
				top: 34px;
				left: 30px;
				width: 280px;
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #666666;
				line-height: 14px;
				text-align: left;
				font-style: normal;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.icon-edit {
				width: 16px;
				height: 16px;
				position: absolute;
				top: 22px;
				right: 14px;
			}

		}

	}

	.tt-list {
		max-height: 350px;
		padding-bottom: 30px;
		overflow: auto;

		.tt-list-item {
			box-sizing: border-box;
			margin: 12px auto;
			width: 345px;
			height: 98px;
			background: #F7F7F7;
			border-radius: 10px;
			position: relative;

			.tt-name-tag {
				position: absolute;
				top: 12px;
				left: 12px;

				.tt-name {
					margin-right: 10px;
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 13px;
					color: #333333;
					line-height: 16px;
				}

				.tt-tag {
					padding: 1px 4px;
					background: rgba(0, 117, 74, 0.06);
					border-radius: 4px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #00754A;
					text-align: center;
				}

			}

			.tt-cont {
				position: absolute;
				top: 34px;
				left: 12px;
				width: 270px;
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #333333;
				line-height: 14px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.tt-line {
				position: absolute;
				top: 58px;
				left: 12px;
				width: 323px;
				height: 1px;
				background-color: #EEEEEE;
			}

			.tt-btn {
				width: 48px;
				height: 26px;
				background: #00754A;
				border-radius: 6px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 12px;
				color: #FFFFFF;
				line-height: 26px;
				text-align: center;
				position: absolute;
				top: 16px;
				right: 12px;
			}

			.tt-d {
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: center;
				align-items: center;
				position: absolute;
				bottom: 12px;
				left: 12px;

				.tt-d-icon {
					width: 16px;
					height: 16px;
				}

				.tt-d-text {
					margin-left: 8px;
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #666666;
					line-height: 14px;
				}
			}

			.tt-icon-edit {
				width: 16px;
				height: 16px;
				position: absolute;
				bottom: 12px;
				right: 40px;
			}

			.tt-icon-del {
				width: 16px;
				height: 16px;
				position: absolute;
				bottom: 12px;
				right: 12px;
			}

		}

		.tt-list-item:first-child {
			margin-top: 0;
		}
	}

	.btn {
		margin: 40px auto 0;
		width: 345px;
		height: 40px;
		background: #00754A;
		border-radius: 10px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		font-size: 15px;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
		font-style: normal;
	}

	.no-more {
		margin: 70px auto 130px;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.img {
			width: 110px;
			height: 100px;
		}

		.tips {
			margin-top: 8px;
			height: 14px;
			font-size: 12px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 14px;
		}
	}

	.list {
		position: relative;
		padding-bottom: 65px;

		.item {
			margin: 0 auto 10px;
			width: 347px;
			height: 88px;

			.img {
				position: absolute;
				width: 100%;
				height: 88px;
				z-index: 0;
			}

			.content-info {
				position: relative;
				width: 100%;
				height: 88px;
				display: flex;

				.dot {
					position: absolute;
					top: 0;
					left: 0;
					width: 49px;
					height: 18px;
					background: linear-gradient(124deg, #ff906d 0%, #ff3d45 100%);
					border-radius: 10px 0px 10px 0px;
					font-size: 11px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #ffffff;
					line-height: 18px;
					text-align: center;
				}

				.left {
					width: 85px;
					display: flex;
					flex-direction: column;
					flex-wrap: nowrap;
					align-content: center;
					justify-content: center;
					align-items: center;

					.price {
						font-size: 0;
						font-family: 'DINA';
						font-weight: bold;
						color: #ff4e4e;
					}

					.condition {
						height: 16px;
						font-size: 11px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #ff4e4e;
						line-height: 16px;
					}
				}

				.content {
					flex: 1;

					.name {
						margin-top: 20px;
						width: 90%;
						height: 32px;
						font-size: 13px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						color: #333333;
						line-height: 16px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
					}

					.condition-time {
						display: flex;
						flex-direction: row;
						flex-wrap: nowrap;
						align-content: center;
						justify-content: center;
						align-items: center;
						margin-top: 6px;

						.condition {
							margin-right: 4px;
							height: 9px;
							font-size: 9px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #00754a;
							line-height: 9px;
							white-space: nowrap;
						}

						.time {
							width: 100%;
							height: 12px;
							font-size: 10px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #999999;
							line-height: 12px;
							white-space: nowrap;
						}
					}
				}

				.right {
					width: 96px;
					display: flex;
					align-content: center;
					align-items: center;
					justify-content: center;

					.btn-get {
						width: 64px;
						height: 26px;
						background: #00754a;
						border-radius: 6px;
						font-size: 12px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						color: #ffffff;
						line-height: 26px;
						text-align: center;
					}

					.img {
						width: 57px;
						height: 44px;
						position: absolute;
						top: 0;
						right: 0;
					}

					.icon-d {
						width: 16px;
						height: 16px;
					}
				}

				.w60 {
					width: 60px;
				}
			}
		}
	}

	.coupon-s {
		max-height: 200px;
		overflow: auto;

		.coupon-grey {
			filter: grayscale(100%);
			/*fire*/
			-webkit-filter: grayscale(100%);
			/*chrome*/
			opacity: 0.6;
		}
	}
}

.linear-gradient {
	background: linear-gradient(180deg, #E3FFF2 0%, #FBFCFE 35%, #FFFFFF 100%);
	border-radius: 16px 16px 0px 0px;

	.bg-serve {
		margin: 24px auto 30px;
		display: block;
		width: 200px;
		height: 104px;
	}

	.items {
		margin-bottom: 20px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: space-between;
		align-items: center;

		.item {
			width: 166px;
			height: 74px;
			background: rgba(0, 117, 74, 0.06);
			border-radius: 10px;
			position: relative;

			.text {
				position: absolute;
				top: 12px;
				left: 12px;
				width: 70px;
				height: 18px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 15px;
				color: #00754A;
				line-height: 18px;
			}

			.time {
				position: absolute;
				top: 34px;
				left: 12px;
				width: 110px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #333333;
				line-height: 14px;
			}

			.icon {
				position: absolute;
				top: 10px;
				right: 12px;
				width: 32px;
				height: 32px;
			}
		}

	}
}

.sku-sheet-dialog {
	// padding: 14px;
	// padding: 46px 15px 14px;
	padding: 0 15px 14px;
	box-sizing: border-box;
	/deep/.van-action-sheet__content{
		padding-top: 46px;
	}

	.icon-close {
		position: absolute;
		top: 14px;
		right: 14px;
		width: 12px;
		height: 12px;
		z-index: 1;
	}

	.h60 {
		height: 60px;
	}

	.goods {
		background-color: #ffffff;
		width: 100%;
		height: 60px;
		position: absolute;
		top: 14px;
		left: 14px;
		padding-bottom: 20px;

		.goods-img {
			width: 60px;
			height: 60px;
			border-radius: 6px;
		}

		.price {
			color: #FF4E4E;
			height: 20px;
			position: absolute;
			top: 2px;
			left: 74px;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: flex-end;
			justify-content: flex-start;
			align-items: flex-end;

			.symbol {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				line-height: 16px;
			}

			.num {
				height: 20px;
				font-family: 'DINA';
				font-weight: bold;
				font-size: 20px;
				line-height: 20px;
			}

			.small-num {
				font-family: 'DINA';
				font-weight: bold;
				font-size: 14px;
			}
		}

		.old-price {
			position: absolute;
			top: 26px;
			left: 74px;
			height: 12px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 10px;
			color: #999999;
			line-height: 12px;
			white-space: nowrap;
		}

		.text {
			position: absolute;
			top: 44px;
			left: 74px;
			width: 273px;
			height: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 11px;
			color: #333333;
			line-height: 14px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.addr {
		margin: 20px auto 0;
		width: 347px;
		background: #F7F7F7;
		border-radius: 10px;
		padding: 8px 10px;
		box-sizing: border-box;

		.addr-line {
			margin: 6px 0;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;

			.c3 {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333333;
				line-height: 16px;
			}

			.m10 {
				font-weight: 500;
				margin-right: 10px;
			}

			.cg {
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #00754A;
				line-height: 14px;
			}

			.cbg {
				padding: 0 4px;
				height: 16px;
				background: #00754A;
				border-radius: 4px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #FFFFFF;
				line-height: 16px;
			}

			.flex1 {
				flex: 1;
			}

			.icon {
				width: 16px;
				height: 16px;
				margin-right: 4px;
			}

			.icon-arrow {
				width: 12px;
				height: 12px;
			}

			.text {
				max-width: 300px;
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333;
				line-height: 16px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.f500 {
				font-weight: 500;
			}

			.c6 {
				color: #666;
			}
		}
	}

	.spec {
		.spec-title {
			margin: 20px 0 4px 0;
			height: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #333333;
			line-height: 18px;
		}

		.cont-items {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			align-content: center;
			align-items: center;
			justify-content: flex-start;

			.cont-item {
				margin: 8px 8px 0 0;
				padding: 8px 10px;
				background: #F7F7F7;
				border-radius: 6px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #666666;
				position: relative;

				.goods-none {
					position: absolute;
					top: -6px;
					right: 0;

					.icon-none {
						width: 32px;
						height: 18px;
					}

					.text {
						position: absolute;
						top: 0;
						left: 50%;
						transform: translateX(-50%);
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						height: 18px;
						line-height: 16px;
						font-size: 10px;
						color: #FFFFFF;
						text-align: center;
						white-space: nowrap;
					}
				}
			}

			.cont-item-s {
				background: rgba(0, 117, 74, 0.06);
				border: 1px solid #00754A;
				color: #00754A;
			}
		}
	}

	.h20 {
		height: 20px;
	}

	.h12 {
		height: 12px;
	}

	.sku-key-val {
		padding: 10px 0;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		min-height: 16px;
		align-items: flex-start;

		.flex1 {
			flex: 1;
		}

		.sku-key {
			height: 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #666666;
			line-height: 16px;
		}

		.num-step {}

		.sku-val {
			max-width: 247px;
			min-height: 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #333333;
			line-height: 16px;
		}

		.green {
			color: #00754A;
		}

		.red {
			color: #FF4E4E;
		}

		.grey {
			color: #CCCCCC;
		}

		.icon-arrow {

			margin: 2px 0 0 2px;
			width: 12px;
			height: 12px;
		}
	}

	.h80 {
		height: 80px;
	}

	.next-box {
		width: 375px;
		position: absolute;
		left: 0;
		bottom: 10px;
		background-color: #ffffff;

		.next-step {
			width: 375px;
			height: 30px;
			background: rgba(0, 117, 74, 0.06);
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #00754A;
			line-height: 30px;
			text-align: center;
		}

		.next-btn {
			margin: 5px auto;
			width: 355px;
			height: 40px;
			background: #00754A;
			border-radius: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #FFFFFF;
			line-height: 40px;
			text-align: center;
		}

		.none {
			background: #CCCCCC;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/product/detail.vue